/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */
import { Language } from '@citrite/translate';
export type locale = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';
export const languages: Language[] = [
  {
    "key": "de",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "Anmelden",
        "message": "Sie werden direkt hierher zurückgebracht, damit Sie dort weitermachen können, wo Sie aufgehört haben.",
        "title": "Melden Sie sich erneut an, um auf Ihr Kundendashboard zuzugreifen"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to a clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "Hinzufügen",
        "addNewClient": "Neuen Kunden hinzufügen",
        "cancel": "Abbrechen",
        "clientPermissionErrorMessage": "Nur autorisierte Teammitglieder für diesen Kunden dürfen diesen Vorgang durchführen.",
        "editClientAssignmentTitle": "Kundenzuweisung bearbeiten",
        "linkSuccessMessage": "Erfolgreich mit dem Kunden verknüpft",
        "linkToClient": "Link zum Kunden",
        "linkedClient": "Linked client",
        "save": "Speichern",
        "searchClientPlaceholder": "Kunden auswählen",
        "successMessage": "Erfolgreich zum Kunden hinzugefügt",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for clients.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "Abmeldung von Early Access"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "Für Ihr Konto sind derzeit keine Kundenentitäten aktiviert.",
        "noConfigurationTitle": "Die neuen Kundenentitäten werden hier angezeigt."
      },
      "clientContactContextBar": {
        "more": "Mehr",
        "noSelection": "Wählen Sie Kontakte aus, um Aktionen anzuzeigen",
        "optionsMenu": "Open client contact options",
        "resetSelection": "Auswahl zurücksetzen",
        "selected": "Ausgewählt"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn’t seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "Nach einem Namen oder einer E-Mail-Adresse suchen",
        "suggestionsLabel": "Vorgeschlagene Personen"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "Im Auftrag von",
        "isPrimary": "(Primär)",
        "missingClientValidationError": "Der Kontakt muss einem Kunden zugeordnet sein",
        "missingContactValidationError": "Kontaktauswahl ist erforderlich",
        "noClientEntity": "Dieser Kontakt ist derzeit keiner Kundenidentität zugeordnet. {<link>}, damit dieser Kontakt fortfahren kann.",
        "noClientEntityLinkText": "Kundenidentität erstellen",
        "notFound": "Keine Ergebnisse gefunden",
        "primaryContactMessage": "Hauptansprechpartner für {{clientEntityName}}",
        "primaryTeamMemberMessage": "Primäres Teammitglied für {{clientEntityName}}",
        "singleClientMessage": "Kontakt für {<clientNameLink>}",
        "singlePrimaryClientMessage": "Hauptansprechpartner für {<clientNameLink>}",
        "teamMemberMessage": "Teammitglied für {{clientEntityName}}",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "Abbrechen",
            "confirmMessage_one": "Möchten Sie diesen Kunden wirklich löschen? Einige Kundenressourcen werden nicht gelöscht.",
            "confirmMessage_other": "Möchten Sie diese Kunden wirklich löschen? Einige Kundenressourcen werden nicht gelöscht.",
            "confirmModalTitle_one": "Client löschen",
            "confirmModalTitle_other": "Clients löschen",
            "errorMessage_one": "Fehler beim Löschen des Clients",
            "errorMessage_other": "Fehler beim Löschen der Clients",
            "folders": "Ordner",
            "foldersInfo": "Verknüpfte Dateien und Ordner bleiben in {<folders>}",
            "label_one": "Client löschen",
            "label_other": "Clients löschen",
            "moreOptions": "Mehr Optionen",
            "people": "Personen",
            "peopleInfo": "Kontakte bleiben in {<people>}",
            "projects": "Projekte",
            "projectsInfo": "Projekte und Kundenanforderungen bleiben in {<projects>}",
            "restore": "Sie können einen gelöschten Kunden innerhalb von {<restoreDays>} über das Menü {<moreOptions>} wiederherstellen.",
            "restoreDays": "45 Tage",
            "solutionsInfo": "Ressourcen aus installierten Lösungen verbleiben in den Lösungsdashboards",
            "successMessage_one": "Gelöschter Kunde",
            "successMessage_other": "Gelöschte Kunden"
          },
          "dropdownLabel": "Actions",
          "editDetails": "Details bearbeiten"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "Auswahl zurücksetzen",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Kundengruppe {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "Erstellen",
          "selectContactPlaceholder": "Nach Name oder E-Mail-Adresse suchen",
          "title": "Primäre Kontaktdaten"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "Die Client-ID ist bereits vorhanden. Geben Sie eine eindeutige Client-ID ein.",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "Client-ID (optional)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "Der interne Name ist bereits vorhanden. Geben Sie einen eindeutigen internen Namen ein.",
            "help": "Dies ist nur für interne Teammitglieder sichtbar.",
            "label": "Interner Anzeigename",
            "requiredError": "Der interne Name darf nicht leer sein."
          },
          "title": "Clientdetails"
        },
        "create": {
          "button": "Erstellen",
          "clientName": "Name",
          "clientType": "Clienttyp",
          "createError": "Fehler beim Erstellen des Clients",
          "createdTitle": "Erstellter Kunde",
          "ftuHelp": "Kurzer Absatz oder Aufzählungspunkte, die den Wert der Erstellung einer Kundenentität beschreiben. ",
          "title": "Neuen Kunden erstellen"
        },
        "createContact": {
          "duplicateError": "Dieser Kontakt existiert bereits. Weisen Sie den vorgeschlagenen Kontakt zu oder geben Sie eine andere E-Mail-Adresse ein."
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "Abbrechen",
        "clientNameLabel": "Name",
        "submitLabel": "Speichern",
        "successMessage": "Kunde aktualisiert",
        "updateDrawerTitle": "Kundendetails bearbeiten",
        "updateError": "Fehler beim Aktualisieren des Kunden"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "Alle",
            "company": "Firma",
            "individual": "Individuell",
            "showMyClientsLabel": "Nur meine Kunden anzeigen",
            "type": "Clienttyp"
          },
          "searchPlaceholder": "Kunden suchen",
          "sortLabel": "Sortieren nach",
          "sortOptions": {
            "createdAsc": "Älteste",
            "createdDesc": "Neueste",
            "createdLabel": "Erstellungsdatum",
            "nameAsc": "A - Z",
            "nameDesc": "Z - A",
            "nameLabel": "Name"
          },
          "sortOrder": "Sortierreihenfolge"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "Einstellungen"
          },
          "create": "Kunden erstellen",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You don't have permissions to manage clients",
          "clearFilter_one": "Filter entfernen",
          "clearFilter_other": "Filter entfernen",
          "description": "Erstellen Sie einen Kunden, um seine Arbeit zu organisieren und zu verwalten.",
          "filterDoesNotMatchClient_one": "Der Filter stimmt mit keinem Kunden überein",
          "filterDoesNotMatchClient_other": "Die Filter stimmen mit keinem Kunden überein",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "Noch keine Kunden erstellt"
        },
        "recentlyDeleted": {
          "description": "Hier werden kürzlich gelöschte Kunden für {{days}} Tage gespeichert.",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "Wiederherstellen",
            "confirmMessageFirst": "Möchten Sie {{clientName}} wirklich wiederherstellen?",
            "confirmMessageSecond": "Jeder Kundenmitarbeiter erhält wieder Zugriff auf die Kundenressourcen.",
            "confirmModalTitle": "Kunden wiederherstellen",
            "errorMessage": "Kunde konnte nicht wiederhergestellt werden",
            "successMessage": "Kunden wiederherstellen"
          },
          "table": {
            "columns": {
              "deletedBy": "Gelöscht von",
              "deletedOn": "Gelöscht am",
              "name": "Name"
            }
          },
          "title": "Kürzlich gelöscht"
        },
        "searchEmptyState": {
          "clearSearch": "Suche löschen",
          "description": "Wir konnten {<searchTerm>} bei keinem Kunden finden.",
          "title": "Ihre Suche stimmt mit keinem Kunden überein"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "Name",
          "primaryContact": {
            "label": "Hauptansprechpartner",
            "no": "Nein",
            "yes": "Ja"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "Personen",
          "services": "Services"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "Kontakte",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "Dateien",
          "overview": "Übersicht",
          "projects": "Projekte"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "Kontakt hinzufügen",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "Hinzufügen",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "Abbrechen",
        "contactExistsError": "Der Kontakt mit dieser E-Mail existiert bereits im Client.",
        "create": "Erstellen",
        "createNewContactTitle": "Neuen Kontakt erstellen",
        "createServices": "Dienste für den Kunden starten.",
        "email": "E-Mail",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "Fehler beim Hinzufügen des Kontakts",
        "errorMessage_other": "Fehler beim Hinzufügen von Kontakten",
        "firstName": "Vorname",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "Nachname",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "Weiter",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "Kontakt hinzugefügt",
        "successMessage_other": "Kontakte hinzugefügt",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "Primäre"
      },
      "contactsTab": {
        "actions": {
          "cancel": "Abbrechen",
          "confirm": "Bestätigen",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "Benutzer verwalten",
          "remove": {
            "confirmModalTitle_one": "Kontakt vom Kunden entfernen",
            "confirmModalTitle_other": "Kontakt vom Kunden entfernen",
            "confirmRemoveMessageFirst_one": "Möchten Sie diesen Kontakt wirklich aus diesem Kunden entfernen?",
            "confirmRemoveMessageFirst_other": "Möchten Sie diese Kontakte wirklich aus diesem Kunden entfernen?",
            "confirmRemoveMessageSecond": "Sie können sie weiterhin unter 'Personen' finden.",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "Kontakt konnte nicht entfernt werden",
            "errorMessage_other": "Kontakte konnten nicht entfernt werden",
            "label": "Entfernen",
            "removeOk": "Entfernen",
            "successMessage_one": "Entfernter Kontakt",
            "successMessage_other": "Entfernte Kontakte"
          },
          "removePrimary": {
            "confirmButtonText": "Hauptbezeichnung entfernen",
            "confirmModalTitle": "Hauptbezeichnung entfernen",
            "confirmRemovePrimaryMessageFirst_one": "Möchten Sie die Bezeichnung dieser Person als Hauptansprechpartner wirklich entfernen?",
            "confirmRemovePrimaryMessageFirst_other": "Möchten Sie die Bezeichnung dieser Personen als Hauptansprechpartner wirklich entfernen?",
            "confirmRemovePrimaryMessageSecond_one": "Diese Person erhält keine Benachrichtigungen mehr über Kundenaktivitäten, bleibt aber weiterhin ein Kontakt für diesen Kunden.",
            "confirmRemovePrimaryMessageSecond_other": "Diese Personen erhalten keine Benachrichtigungen mehr über Kundenaktivitäten, bleiben aber weiterhin Kontakte für diesen Kunden.",
            "errorMessage_one": "Kontakt konnte nicht aktualisiert werden",
            "errorMessage_other": "Kontakte konnten nicht aktualisiert werden",
            "label": "Bezeichnung als Hauptansprechpartner entfernen",
            "successMessage_one": "Aktualisierte Kontaktdaten",
            "successMessage_other": "Aktualisierte Kontaktdaten"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "Teammitglied aus dem Kunden entfernen",
            "confirmRemoveMessage": "Möchten Sie {{contactName}} wirklich entfernen?",
            "errorMessage": "Teammitglied konnte nicht entfernt werden",
            "removeOk": "Entfernen",
            "successMessage": "Entferntes Teammitglied"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "Bezeichnung als Hauptansprechpartner entfernen",
            "confirmModalTitle": "Bezeichnung als Hauptansprechpartner entfernen",
            "confirmRemovePrimaryMessage": "Möchten Sie die Bezeichnung dieser Person als Hauptteammitglied wirklich entfernen?",
            "errorMessage": "Teammitglied konnte nicht aktualisiert werden",
            "successMessage": "Teammitglied erfolgreich aktualisiert"
          },
          "setPrimary": {
            "confirmButtonText_one": "Zum Hauptansprechpartner machen",
            "confirmButtonText_other": "Zu Hauptansprechpartnern machen",
            "confirmModalTitle_one": "Zum Hauptansprechpartner machen",
            "confirmModalTitle_other": "Zu Hauptansprechpartnern machen",
            "confirmSetPrimaryMessageFirst_one": "Möchten Sie die diese Person wirklich zum Hauptansprechpartner für diesen Kunden machen?",
            "confirmSetPrimaryMessageFirst_other": "Möchten Sie die diese Personen wirklich zu Hauptansprechpartnern für diesen Kunden machen?",
            "confirmSetPrimaryMessageSecond": "Hauptansprechpartner erhalten Benachrichtigungen über die Kundenaktivität und werden allen neuen Kundenaufgaben zugewiesen.",
            "errorMessage_one": "Hauptansprechpartner konnte nicht festgelegt werden",
            "errorMessage_other": "Hauptansprechpartner konnten nicht festgelegt werden",
            "label": "Zum Hauptansprechpartner machen",
            "successMessage_one": "Aktualisierte Kontaktdaten",
            "successMessage_other": "Aktualisierte Kontaktdaten"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "Zum primären Teammitglied machen",
            "confirmModalTitle": "Zum primären Teammitglied machen",
            "confirmSetPrimaryMessage": "Möchten Sie die diese Person wirklich zum Hauptteammitglied für diesen Kunden machen?",
            "errorMessage": "Teammitglied konnte nicht aktualisiert werden",
            "successMessage": "Teammitglied erfolgreich aktualisiert"
          }
        },
        "email": "E-Mail",
        "name": "Name"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "Kontakt hinzufügen",
        "addError": "Kontakte konnten nicht hinzugefügt werden",
        "addSuccessMessage": "Kontakt wurde hinzugefügt",
        "confirmAddClientInfo": "Möchten Sie {{contactName}} wirklich als Kontakt hinzufügen?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "Der Kontakt wird nicht benachrichtigt.",
        "sameDomainContactsMessage_one": "Es gibt 1 Kontakt mit derselben E-Mail-Domäne wie der Hauptansprechpartner.",
        "sameDomainContactsMessage_other": "Es gibt {{count}} Kontakte mit derselben E-Mail-Domäne wie der Hauptansprechpartner.",
        "selectSuggestedClient": "Select suggested contact",
        "title": "Vorgeschlagene Kontakte"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "Kontakt hinzufügen",
        "addContacts_other": "Kontakte hinzufügen",
        "addSuccess_one": "Kontakt hinzugefügt",
        "addSuccess_other": "Kontakte hinzugefügt",
        "cancel": "Abbrechen",
        "emailField": "E-Mail",
        "nameField": "Name",
        "selectContactsInfoMessage": "Wählen Sie die Kontakte aus, die Sie diesem Kunden hinzufügen möchten.",
        "title": "Vorgeschlagene Kontakte hinzufügen"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "Geben Sie eine gültige E-Mail-Adresse ein"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "Geben Sie {{name}} ein"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "Keine Hauptansprechpartner",
          "primaryContact": "(Primär)",
          "title": "Kontakte",
          "viewAll": "Alle anzeigen"
        },
        "clientDetails": {
          "edit": "Bearbeiten",
          "properties": {
            "clientId": "Client-ID",
            "clientType": "Clienttyp",
            "internalName": "Anzeigename"
          },
          "title": "Clientdetails"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Join the service team to get access to all client requests, services, and files.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "Starten Sie einen Dienst, um Dateien oder Informationen anzufordern und Dokumente zur Unterschrift oder Genehmigung zu senden.",
            "title": "Für diesen Kunden wurde keine Arbeit erstellt"
          },
          "title": "Kundenanforderungen"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "Zum Serviceteam hinzufügen",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(Primär)",
          "remove": "Aus dem Client entfernen",
          "removePrimaryDesignation": "Bezeichnung als Hauptansprechpartner entfernen",
          "search": "Mindestens ein Teammitglied auswählen",
          "searchPlaceholder": "Nach Name oder E-Mail-Adresse suchen",
          "setPrimary": "Zum primären Teammitglied machen",
          "title": "Assigned team members",
          "viewAll": "Alle anzeigen"
        },
        "suggestedClients": {
          "title": "Vorgeschlagene Kunden"
        },
        "suggestedContacts": {
          "title": "Vorgeschlagene Kontakte",
          "viewAll": "Alle anzeigen"
        }
      }
    }
  },
  {
    "key": "en",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "Sign in",
        "message": "We'll bring you right back here so you can pick up where you left off.",
        "title": "Sign in again to access your client dashboard"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "Add",
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "clientPermissionErrorMessage": "Only authorized team members for this client are permitted to perform this operation.",
        "editClientAssignmentTitle": "Manage linked client",
        "linkSuccessMessage": "Successfully linked to client",
        "linkToClient": "Link to client",
        "linkedClient": "Linked client",
        "save": "Save",
        "searchClientPlaceholder": "Select a client",
        "successMessage": "Successfully added to client",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for {{type}}.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "Opt-Out of Early Access"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "Unfortunately your account does not have client entities enabled at the moment.",
        "noConfigurationTitle": "The new client entities will show up here."
      },
      "clientContactContextBar": {
        "more": "More",
        "noSelection": "Select contacts to see actions",
        "optionsMenu": "Open client contact options",
        "resetSelection": "Reset selection",
        "selected": "Selected"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn't seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "Search for a name or email address",
        "suggestionsLabel": "Suggested people"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "On behalf of",
        "isPrimary": "(Primary)",
        "missingClientValidationError": "Contact must be associated to a client",
        "missingContactValidationError": "Contact selection is required",
        "noClientEntity": "This contact is not currently associated with any client entity. {<link>} for this contact to proceed.",
        "noClientEntityLinkText": "Create a client entity",
        "notFound": "No results found",
        "primaryContactMessage": "Primary contact for {{clientEntityName}}",
        "primaryTeamMemberMessage": "Primary team member for {{clientEntityName}}",
        "singleClientMessage": "Contact for {<clientNameLink>}",
        "singlePrimaryClientMessage": "Primary contact for {<clientNameLink>}",
        "teamMemberMessage": "Team member for {{clientEntityName}}",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "Cancel",
            "confirmMessage_one": "Are you sure you want to delete this client? Some client resources won't be deleted.",
            "confirmMessage_other": "Are you sure you want to delete these clients? Some client resources won't be deleted.",
            "confirmModalTitle_one": "Delete client",
            "confirmModalTitle_other": "Delete clients",
            "errorMessage_one": "Failed to delete client",
            "errorMessage_other": "Failed to delete clients",
            "folders": "Folders",
            "foldersInfo": "Linked files and folders will stay in {<folders>}",
            "label_one": "Delete client",
            "label_other": "Delete clients",
            "moreOptions": "More options",
            "people": "People",
            "peopleInfo": "Contacts will stay in {<people>}",
            "projects": "Projects",
            "projectsInfo": "Projects and client requests will stay in {<projects>}",
            "restore": "You can restore a deleted client within {<restoreDays>} via the {<moreOptions>} menu.",
            "restoreDays": "45 days",
            "solutionsInfo": "Resources from installed solutions will stay in solution dashboards",
            "successMessage_one": "Deleted client",
            "successMessage_other": "Deleted clients"
          },
          "dropdownLabel": "Actions",
          "editDetails": "Edit details"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "Reset selection",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Client group {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "Create new",
          "selectContactPlaceholder": "Search by name or email",
          "title": "Primary contact details"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "Client ID already exists, enter a unique client ID.",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "Client ID (optional)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "Internal name already exists, enter a unique internal name.",
            "help": "This is only visible to internal team members.",
            "label": "Internal display name",
            "requiredError": "Internal name cannot be empty."
          },
          "title": "Client details"
        },
        "create": {
          "button": "Create",
          "clientName": "Name",
          "clientType": "Client type",
          "createError": "Failed to create client",
          "createdTitle": "Created client",
          "ftuHelp": "Short paragraph or bullet points describing the value of creating a client entity. ",
          "title": "Create new client"
        },
        "createContact": {
          "duplicateError": "This contact already exists. Assign suggested contact or enter a different email address."
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "Cancel",
        "clientNameLabel": "Name",
        "submitLabel": "Save",
        "successMessage": "Updated client",
        "updateDrawerTitle": "Edit client details",
        "updateError": "Failed to update client"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "All",
            "company": "Company",
            "individual": "Individual",
            "showMyClientsLabel": "Show only my clients",
            "type": "Client type"
          },
          "searchPlaceholder": "Search clients",
          "sortLabel": "Sort by",
          "sortOptions": {
            "createdAsc": "Oldest",
            "createdDesc": "Newest",
            "createdLabel": "Created date",
            "nameAsc": "A - Z",
            "nameDesc": "Z - A",
            "nameLabel": "Name"
          },
          "sortOrder": "Sort order"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "Settings"
          },
          "create": "Create client",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You're not on the service team for any clients yet.",
          "clearFilter_one": "Clear filter",
          "clearFilter_other": "Clear filters",
          "description": "Create a client to organize and manage their work.",
          "filterDoesNotMatchClient_one": "The filter doesn't match any client",
          "filterDoesNotMatchClient_other": "The filters don't match any client",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "No clients created yet"
        },
        "recentlyDeleted": {
          "description": "We'll store recently deleted clients here for {{days}} days.",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "Restore",
            "confirmMessageFirst": "Are you sure you want to restore {{clientName}}?",
            "confirmMessageSecond": "Everyone on the client will regain access to the client resources.",
            "confirmModalTitle": "Restore client",
            "errorMessage": "Failed to restore client",
            "successMessage": "Restored client"
          },
          "table": {
            "columns": {
              "deletedBy": "Deleted by",
              "deletedOn": "Deleted on",
              "name": "Name"
            }
          },
          "title": "Recently deleted"
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We couldn't find {<searchTerm>} in any client.",
          "title": "Your search doesn't match any client"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "Name",
          "primaryContact": {
            "label": "Primary contact",
            "no": "No",
            "yes": "Yes"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "People",
          "services": "Services"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "Contacts",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "Files",
          "overview": "Overview",
          "projects": "Projects"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "Add contact",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "Add",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "Cancel",
        "contactExistsError": "Contact with this email already exists in the client.",
        "create": "Create",
        "createNewContactTitle": "Create a new contact",
        "createServices": "Create services for the client.",
        "email": "Email",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "Failed to add contact",
        "errorMessage_other": "Failed to add contacts",
        "firstName": "First name",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "Last name",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "Next",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "Added contact",
        "successMessage_other": "Added contacts",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "Primary"
      },
      "contactsTab": {
        "actions": {
          "cancel": "Cancel",
          "confirm": "Confirm",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "Manage user",
          "remove": {
            "confirmModalTitle_one": "Remove contact from client",
            "confirmModalTitle_other": "Remove contacts from client",
            "confirmRemoveMessageFirst_one": "Are you sure you want to remove this contact from this client?",
            "confirmRemoveMessageFirst_other": "Are you sure you want to remove these contacts from this client?",
            "confirmRemoveMessageSecond": "You'll still be able to find them in {<people>}.",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "Contact could not be removed",
            "errorMessage_other": "Contacts could not be removed",
            "label": "Remove",
            "removeOk": "Remove",
            "successMessage_one": "Removed contact",
            "successMessage_other": "Removed contacts"
          },
          "removePrimary": {
            "confirmButtonText": "Remove primary designation",
            "confirmModalTitle": "Remove primary designation",
            "confirmRemovePrimaryMessageFirst_one": "Are you sure you want to remove this person's primary contact designation?",
            "confirmRemovePrimaryMessageFirst_other": "Are you sure you want to remove these people's primary contact designation?",
            "confirmRemovePrimaryMessageSecond_one": "This person will no longer receive notifications for client activity, but they'll still be a contact for this client.",
            "confirmRemovePrimaryMessageSecond_other": "They will no longer receive notifications for client activity, but they'll still be contacts for this client.",
            "errorMessage_one": "Contact could not be updated",
            "errorMessage_other": "Contacts could not be updated",
            "label": "Remove primary designation",
            "successMessage_one": "Updated contact details",
            "successMessage_other": "Updated contacts details"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "Remove team member from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Team member could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed team member"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "Remove primary designation",
            "confirmModalTitle": "Remove primary designation",
            "confirmRemovePrimaryMessage": "Are you sure you want to remove this person's primary team member designation?",
            "errorMessage": "Team member could not be updated",
            "successMessage": "Updated team member successfully"
          },
          "setPrimary": {
            "confirmButtonText_one": "Make primary contact",
            "confirmButtonText_other": "Make primary contacts",
            "confirmModalTitle_one": "Make primary contact",
            "confirmModalTitle_other": "Make primary contacts",
            "confirmSetPrimaryMessageFirst_one": "Are you sure you want to make this person a primary contact for this client?",
            "confirmSetPrimaryMessageFirst_other": "Are you sure you want to make these people primary contacts for this client?",
            "confirmSetPrimaryMessageSecond": "Primary contacts receive notifications of client activity and are assigned to all new client tasks.",
            "errorMessage_one": "Primary contact could not be set",
            "errorMessage_other": "Primary contacts could not be set",
            "label": "Make primary contact",
            "successMessage_one": "Updated contact details",
            "successMessage_other": "Updated contacts details"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "Make primary team member",
            "confirmModalTitle": "Make primary team member",
            "confirmSetPrimaryMessage": "Are you sure you want to make this person a primary team member for this client?",
            "errorMessage": "Team member could not be updated",
            "successMessage": "Updated team member successfully"
          }
        },
        "email": "Email",
        "name": "Name"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "Add contact",
        "addError": "Contacts could not be added",
        "addSuccessMessage": "Added contact successfully",
        "confirmAddClientInfo": "Are you sure you want to add {{contactName}} as a contact?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "The contact will not be notified.",
        "sameDomainContactsMessage_one": "There is 1 contact with the same email domain as the primary contact.",
        "sameDomainContactsMessage_other": "There are {{count}} contacts with the same email domain as the primary contact.",
        "selectSuggestedClient": "Select suggested contact",
        "title": "Suggested contacts"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "Add contact",
        "addContacts_other": "Add contacts",
        "addSuccess_one": "Added contact",
        "addSuccess_other": "Added contacts",
        "cancel": "Cancel",
        "emailField": "Email",
        "nameField": "Name",
        "selectContactsInfoMessage": "Select the contacts you'd like to add to this client.",
        "title": "Add suggested contacts"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "Please provide a valid email address"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "Please enter {{name}}"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "No primary contacts",
          "primaryContact": "(Primary)",
          "title": "Contacts",
          "viewAll": "View all"
        },
        "clientDetails": {
          "edit": "Edit",
          "properties": {
            "clientId": "Client ID",
            "clientType": "Client type",
            "internalName": "Display name"
          },
          "title": "Client details"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Admins can join and manage this client’s service team.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "Start a service to request files or information, send documents for signature or approvals.",
            "title": "No work has been created for this client"
          },
          "title": "Client requests"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "Add team members",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(Primary)",
          "remove": "Remove from client",
          "removePrimaryDesignation": "Remove primary designation",
          "search": "Select one or multiple team members",
          "searchPlaceholder": "Search by name or email",
          "setPrimary": "Make primary team member",
          "title": "Assigned team members",
          "viewAll": "View all"
        },
        "suggestedClients": {
          "title": "Suggested clients"
        },
        "suggestedContacts": {
          "title": "Suggested contacts",
          "viewAll": "View all"
        }
      }
    }
  },
  {
    "key": "es",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "Iniciar sesión",
        "message": "Lo traeremos de regreso aquí para que pueda continuar donde lo dejó.",
        "title": "Inicie sesión de nuevo para acceder al panel de mandos del cliente"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to a clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "Agregar",
        "addNewClient": "Agregar nuevo cliente",
        "cancel": "Cancelar",
        "clientPermissionErrorMessage": "Solo los miembros autorizados del equipo de este cliente pueden realizar esta operación.",
        "editClientAssignmentTitle": "Modificar asignación de clientes",
        "linkSuccessMessage": "Vinculado correctamente al cliente",
        "linkToClient": "Vincular al cliente",
        "linkedClient": "Linked client",
        "save": "Guardar",
        "searchClientPlaceholder": "Seleccionar un cliente",
        "successMessage": "Agregado correctamente al cliente",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for clients.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "Optar por no participar en el acceso anticipado"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "Lamentablemente su cuenta no tiene entidades cliente habilitadas en este momento.",
        "noConfigurationTitle": "Las nuevas entidades cliente se mostrarán aquí."
      },
      "clientContactContextBar": {
        "more": "Más",
        "noSelection": "Seleccionar contactos para ver las acciones",
        "optionsMenu": "Open client contact options",
        "resetSelection": "Restablecer selección",
        "selected": "Seleccionadas"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn’t seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "Buscar un nombre o una dirección de correo electrónico",
        "suggestionsLabel": "Personas sugeridas"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "En nombre de",
        "isPrimary": "(Principal)",
        "missingClientValidationError": "El contacto debe estar asociado a un cliente",
        "missingContactValidationError": "La selección de contactos es obligatoria",
        "noClientEntity": "Este contacto no está asociado actualmente a ninguna entidad cliente. {<link>} para que este contacto continúe.",
        "noClientEntityLinkText": "Cree una entidad cliente",
        "notFound": "No hay resultados",
        "primaryContactMessage": "Contacto principal para {{clientEntityName}}",
        "primaryTeamMemberMessage": "Miembro principal del equipo para {{clientEntityName}}",
        "singleClientMessage": "Contacto para {<clientNameLink>}",
        "singlePrimaryClientMessage": "Contacto principal para {<clientNameLink>}",
        "teamMemberMessage": "Miembro del equipo para {{clientEntityName}}",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "Cancelar",
            "confirmMessage_one": "¿Seguro que quiere eliminar este cliente? Algunos recursos del cliente no se eliminarán.",
            "confirmMessage_other": "¿Seguro que quiere eliminar estos clientes? Algunos recursos de los clientes no se eliminarán.",
            "confirmModalTitle_one": "Eliminar cliente",
            "confirmModalTitle_other": "Eliminar clientes",
            "errorMessage_one": "No se pudo eliminar el cliente",
            "errorMessage_other": "No se pudieron eliminar los clientes",
            "folders": "Carpetas",
            "foldersInfo": "Los archivos y carpetas vinculados permanecerán en {<folders>}",
            "label_one": "Eliminar cliente",
            "label_other": "Eliminar clientes",
            "moreOptions": "Más opciones",
            "people": "Personas",
            "peopleInfo": "Los contactos permanecerán en {<people>}",
            "projects": "Proyectos",
            "projectsInfo": "Los proyectos y las solicitudes de clientes permanecerán en {<projects>}",
            "restore": "Puede restaurar un cliente eliminado en un plazo de {<restoreDays>} a través del menú {<moreOptions>}.",
            "restoreDays": "45 días",
            "solutionsInfo": "Los recursos de las soluciones instaladas permanecerán en los paneles de la solución",
            "successMessage_one": "Cliente eliminado",
            "successMessage_other": "Clientes eliminados"
          },
          "dropdownLabel": "Actions",
          "editDetails": "Modificar detalles"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "Restablecer selección",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Grupo de clientes {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "Crear nuevo",
          "selectContactPlaceholder": "Buscar por nombre o correo electrónico",
          "title": "Detalles del contacto principal"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "El ID de cliente ya existe; introduzca un ID de cliente único.",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "ID de cliente (optativo)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "El nombre interno ya existe; introduzca un nombre interno único.",
            "help": "Esto solo es visible para los miembros internos del equipo.",
            "label": "Nombre simplificado interno",
            "requiredError": "El nombre interno no puede quedar vacío."
          },
          "title": "Detalles del cliente"
        },
        "create": {
          "button": "Crear",
          "clientName": "Nombre",
          "clientType": "Tipo de cliente",
          "createError": "Error al crear el cliente",
          "createdTitle": "Cliente creado",
          "ftuHelp": "Párrafo breve o viñetas que describan el valor de crear una entidad cliente. ",
          "title": "Crear nuevo cliente"
        },
        "createContact": {
          "duplicateError": "Este contacto ya existe. Asigne el contacto sugerido o introduzca una dirección de correo electrónico diferente."
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "Cancelar",
        "clientNameLabel": "Nombre",
        "submitLabel": "Guardar",
        "successMessage": "Cliente actualizado",
        "updateDrawerTitle": "Modificar detalles del cliente",
        "updateError": "Error al actualizar el cliente"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "Todo",
            "company": "Empresa",
            "individual": "Individual",
            "showMyClientsLabel": "Mostrar solo mis clientes",
            "type": "Tipo de cliente"
          },
          "searchPlaceholder": "Buscar clientes",
          "sortLabel": "Ordenar por",
          "sortOptions": {
            "createdAsc": "Más antiguo",
            "createdDesc": "Más reciente",
            "createdLabel": "Fecha de creación",
            "nameAsc": "A - Z",
            "nameDesc": "Z - A",
            "nameLabel": "Nombre"
          },
          "sortOrder": "Criterio de ordenación"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "Parámetros"
          },
          "create": "Crear cliente",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You don't have permissions to manage clients",
          "clearFilter_one": "Borrar filtro",
          "clearFilter_other": "Borrar filtros",
          "description": "Cree un cliente para organizar y gestionar su trabajo.",
          "filterDoesNotMatchClient_one": "El filtro no coincide con ningún cliente",
          "filterDoesNotMatchClient_other": "Los filtros no coinciden con ningún cliente",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "Aún no se han creado clientes"
        },
        "recentlyDeleted": {
          "description": "Almacenaremos aquí durante un plazo de {{days}} días los clientes eliminados recientemente.",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "Restore",
            "confirmMessageFirst": "¿Seguro que quiere restaurar {{clientName}}?",
            "confirmMessageSecond": "Todos los miembros del cliente recuperarán el acceso a los recursos del cliente.",
            "confirmModalTitle": "Restaurar cliente",
            "errorMessage": "Error al restaurar cliente",
            "successMessage": "Cliente restaurado"
          },
          "table": {
            "columns": {
              "deletedBy": "Eliminación por",
              "deletedOn": "Eliminado el",
              "name": "Nombre"
            }
          },
          "title": "Eliminados recientemente"
        },
        "searchEmptyState": {
          "clearSearch": "Borrar búsqueda",
          "description": "No pudimos encontrar {<searchTerm>} en ningún cliente.",
          "title": "Su búsqueda no coincide con ningún cliente"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "Nombre",
          "primaryContact": {
            "label": "Contacto principal",
            "no": "No",
            "yes": "Sí"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "Personas",
          "services": "Servicios"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "Contactos",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "Archivos",
          "overview": "Vista general",
          "projects": "Proyectos"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "Agregar contacto",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "Agregar",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "Cancelar",
        "contactExistsError": "El contacto con este correo electrónico ya existe en el cliente.",
        "create": "Crear",
        "createNewContactTitle": "Crear contacto nuevo",
        "createServices": "Crear servicios para el cliente.",
        "email": "Correo electrónico",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "Error al agregar el contacto",
        "errorMessage_other": "Error al agregar los contactos",
        "firstName": "Nombre",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "Apellido",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "Siguiente",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "Contacto agregado",
        "successMessage_other": "Contactos agregados",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "Principal"
      },
      "contactsTab": {
        "actions": {
          "cancel": "Cancelar",
          "confirm": "Confirmar",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "Administrar usuario",
          "remove": {
            "confirmModalTitle_one": "Quitar contacto del cliente",
            "confirmModalTitle_other": "Quitar contactos del cliente",
            "confirmRemoveMessageFirst_one": "¿Seguro que quiere quitar este contacto de este cliente?",
            "confirmRemoveMessageFirst_other": "¿Seguro que quiere quitar estos contactos de este cliente?",
            "confirmRemoveMessageSecond": "Aún podrá encontrarlos en Personas.",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "No se pudo quitar el contacto",
            "errorMessage_other": "No se pudieron quitar los contactos",
            "label": "Quitar",
            "removeOk": "Quitar",
            "successMessage_one": "Contacto eliminado",
            "successMessage_other": "Contactos eliminados"
          },
          "removePrimary": {
            "confirmButtonText": "Quitar designación principal",
            "confirmModalTitle": "Quitar designación principal",
            "confirmRemovePrimaryMessageFirst_one": "¿Seguro que quiere quitar la designación de contacto principal de esta persona?",
            "confirmRemovePrimaryMessageFirst_other": "¿Seguro que quiere quitar la designación de contacto principal de estas personas?",
            "confirmRemovePrimaryMessageSecond_one": "Esta persona ya no recibirá notificaciones sobre la actividad del cliente, pero seguirá siendo un contacto de este cliente.",
            "confirmRemovePrimaryMessageSecond_other": "Ya no recibirán notificaciones sobre la actividad del cliente, pero seguirán siendo contactos de este cliente.",
            "errorMessage_one": "No se pudo actualizar el contacto",
            "errorMessage_other": "No se pudieron actualizar los contactos",
            "label": "Quitar designación principal",
            "successMessage_one": "Detalles de contacto actualizados",
            "successMessage_other": "Detalles de contactos actualizados"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "Quitar miembro del equipo del cliente",
            "confirmRemoveMessage": "¿Seguro que quiere quitar {{contactName}}?",
            "errorMessage": "No se pudo quitar al miembro del equipo",
            "removeOk": "Quitar",
            "successMessage": "Miembro del equipo eliminado"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "Quitar designación principal",
            "confirmModalTitle": "Quitar designación principal",
            "confirmRemovePrimaryMessage": "¿Seguro que quiere quitar la designación de miembro principal del equipo de esta persona?",
            "errorMessage": "No se pudo actualizar el miembro del equipo",
            "successMessage": "Miembro del equipo actualizado correctamente"
          },
          "setPrimary": {
            "confirmButtonText_one": "Hacer contacto principal",
            "confirmButtonText_other": "Hacer contactos principales",
            "confirmModalTitle_one": "Hacer contacto principal",
            "confirmModalTitle_other": "Hacer contactos principales",
            "confirmSetPrimaryMessageFirst_one": "¿Seguro que quiere hacer a esta persona contacto principal de este cliente?",
            "confirmSetPrimaryMessageFirst_other": "¿Seguro que quiere hacer a estas personas contactos principales de este cliente?",
            "confirmSetPrimaryMessageSecond": "Los contactos principales reciben notificaciones de la actividad del cliente y se les asignan todas las tareas nuevas del cliente.",
            "errorMessage_one": "No se pudo establecer el contacto principal",
            "errorMessage_other": "No se pudieron establecer los contactos principales",
            "label": "Hacer contacto principal",
            "successMessage_one": "Detalles de contacto actualizados",
            "successMessage_other": "Detalles de contactos actualizados"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "Hacer miembro principal del equipo",
            "confirmModalTitle": "Hacer miembro principal del equipo",
            "confirmSetPrimaryMessage": "¿Seguro que quiere hacer a esta persona miembro principal del equipo de este cliente?",
            "errorMessage": "No se pudo actualizar el miembro del equipo",
            "successMessage": "Miembro del equipo actualizado correctamente"
          }
        },
        "email": "Correo electrónico",
        "name": "Nombre"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "Agregar contacto",
        "addError": "No se pudieron agregar los contactos",
        "addSuccessMessage": "Contacto agregado correctamente",
        "confirmAddClientInfo": "¿Seguro que quiere agregar {{contactName}} como contacto?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "No se notificará al contacto.",
        "sameDomainContactsMessage_one": "Hay 1 contacto con el mismo dominio de correo electrónico que el contacto principal.",
        "sameDomainContactsMessage_other": "Hay {{count}} contactos con el mismo dominio de correo electrónico que el contacto principal.",
        "selectSuggestedClient": "Select suggested contact",
        "title": "Contactos sugeridos"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "Agregar contacto",
        "addContacts_other": "Agregar contactos",
        "addSuccess_one": "Contacto agregado",
        "addSuccess_other": "Contactos agregados",
        "cancel": "Cancelar",
        "emailField": "Correo electrónico",
        "nameField": "Nombre",
        "selectContactsInfoMessage": "Seleccione los contactos que quiere agregar a este cliente.",
        "title": "Agregar contactos sugeridos"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "Proporcione una dirección de correo electrónico válida"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "Introduzca {{name}}"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "No hay contactos principales",
          "primaryContact": "(Principal)",
          "title": "Contactos",
          "viewAll": "Ver todo"
        },
        "clientDetails": {
          "edit": "Editar",
          "properties": {
            "clientId": "ID de cliente",
            "clientType": "Tipo de cliente",
            "internalName": "Nombre simplificado"
          },
          "title": "Detalles del cliente"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Join the service team to get access to all client requests, services, and files.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "Inicie un servicio para solicitar archivos o información y enviar documentos para firma o aprobación.",
            "title": "No se ha creado ningún trabajo para este cliente"
          },
          "title": "Solicitudes de clientes"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "Agregar al equipo de servicio",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(Principal)",
          "remove": "Quitar del cliente",
          "removePrimaryDesignation": "Quitar designación principal",
          "search": "Seleccione uno o varios miembros del equipo",
          "searchPlaceholder": "Buscar por nombre o correo electrónico",
          "setPrimary": "Hacer miembro principal del equipo",
          "title": "Assigned team members",
          "viewAll": "Ver todo"
        },
        "suggestedClients": {
          "title": "Clientes sugeridos"
        },
        "suggestedContacts": {
          "title": "Contactos sugeridos",
          "viewAll": "Ver todo"
        }
      }
    }
  },
  {
    "key": "fr",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "Connexion",
        "message": "Nous vous ramènerons ici pour que vous puissiez reprendre là où vous vous étiez arrêté.",
        "title": "Pour accéder au tableau de bord de votre client, reconnectez-vous"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to a clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "Ajouter",
        "addNewClient": "Ajouter un nouveau client",
        "cancel": "Annuler",
        "clientPermissionErrorMessage": "Seuls les membres de l’équipe autorisés pour ce client sont autorisés à effectuer cette opération.",
        "editClientAssignmentTitle": "Modifier l'attribution du client",
        "linkSuccessMessage": "Lié au client avec succès",
        "linkToClient": "Lier au client",
        "linkedClient": "Linked client",
        "save": "Sauvegarder",
        "searchClientPlaceholder": "Sélectionner un client",
        "successMessage": "Ajouté avec succès au client",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for clients.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "Se désinscrire de l'accès anticipé"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "Malheureusement, les entités clientes ne sont pas activées sur votre compte pour le moment.",
        "noConfigurationTitle": "Les nouvelles entités clientes s'afficheront ici."
      },
      "clientContactContextBar": {
        "more": "Plus",
        "noSelection": "Sélectionnez des contacts pour voir les actions",
        "optionsMenu": "Open client contact options",
        "resetSelection": "Réinitialiser la sélection",
        "selected": "Sélectionnées"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn’t seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "Rechercher un nom ou une adresse e-mail",
        "suggestionsLabel": "Personnes suggérées"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "Au nom de",
        "isPrimary": "(Principal)",
        "missingClientValidationError": "Le contact doit être associé à un client",
        "missingContactValidationError": "La sélection du contact est obligatoire",
        "noClientEntity": "Actuellement, ce contact n'est associé à aucune entité cliente. {<link>} pour maintenir ce contact.",
        "noClientEntityLinkText": "Créer une entité cliente",
        "notFound": "Aucun résultat trouvé",
        "primaryContactMessage": "Contact principal de {{clientEntityName}}",
        "primaryTeamMemberMessage": "Membre principal de l'équipe de {{clientEntityName}}",
        "singleClientMessage": "Contact de {<clientNameLink>}",
        "singlePrimaryClientMessage": "Primary contact for {<clientNameLink>}",
        "teamMemberMessage": "Membre de l'équipe de {{clientEntityName}}",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "Annuler",
            "confirmMessage_one": "Êtes-vous sûr de vouloir supprimer ce client ? Certaines ressources client ne seront pas supprimées.",
            "confirmMessage_other": "Êtes-vous sûr de vouloir supprimer ces clients ? Certaines ressources client ne seront pas supprimées.",
            "confirmModalTitle_one": "Supprimer client",
            "confirmModalTitle_other": "Supprimer clients",
            "errorMessage_one": "Impossible de supprimer le client",
            "errorMessage_other": "Impossible de supprimer les clients",
            "folders": "Dossiers",
            "foldersInfo": "Les fichiers et dossiers liés resteront dans {<folders>}",
            "label_one": "Supprimer client",
            "label_other": "Supprimer clients",
            "moreOptions": "Plus d'options",
            "people": "Personnes",
            "peopleInfo": "Les contacts resteront dans {<people>}",
            "projects": "Projets",
            "projectsInfo": "Les projets et les demandes du client resteront dans {<projects>}",
            "restore": "Vous pouvez restaurer un client supprimé dans {<restoreDays>} via le menu {<moreOptions>}.",
            "restoreDays": "45 jours",
            "solutionsInfo": "Les ressources des solutions installées resteront dans les tableaux de bord des solutions",
            "successMessage_one": "Client supprimé",
            "successMessage_other": "Clients supprimés"
          },
          "dropdownLabel": "Actions",
          "editDetails": "Modifier les détails"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "Réinitialiser la sélection",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Groupe client {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "Créer",
          "selectContactPlaceholder": "Rechercher par nom ou e-mail",
          "title": "Coordonnées du contact principal"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "L'ID client existe déjà, saisissez un ID client unique.",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "ID client (facultatif)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "Le nom interne existe déjà, saisissez un nom interne unique.",
            "help": "Ceci n'est visible que par les membres de l'équipe interne.",
            "label": "Nom d'affichage interne",
            "requiredError": "Le nom interne ne peut pas être vide."
          },
          "title": "Détails du client"
        },
        "create": {
          "button": "Créer",
          "clientName": "Nom",
          "clientType": "Type de client",
          "createError": "Impossible de créer le client",
          "createdTitle": "Client créé",
          "ftuHelp": "Court paragraphe ou liste à puces décrivant l'intérêt de créer une entité cliente. ",
          "title": "Créer nouveau client"
        },
        "createContact": {
          "duplicateError": "Ce contact existe déjà. Attribuez un contact suggéré ou saisissez une autre adresse e-mail."
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "Annuler",
        "clientNameLabel": "Nom",
        "submitLabel": "Sauvegarder",
        "successMessage": "Client mis à jour",
        "updateDrawerTitle": "Modifier les informations du client",
        "updateError": "Impossible de mettre à jour le client"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "Tout",
            "company": "Société",
            "individual": "Individuel",
            "showMyClientsLabel": "Afficher uniquement mes clients",
            "type": "Type de client"
          },
          "searchPlaceholder": "Rechercher des clients",
          "sortLabel": "Trier par",
          "sortOptions": {
            "createdAsc": "Plus ancien",
            "createdDesc": "Plus récent",
            "createdLabel": "Date de création",
            "nameAsc": "A - Z",
            "nameDesc": "Z - A",
            "nameLabel": "Nom"
          },
          "sortOrder": "Ordre de tri"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "Paramètres"
          },
          "create": "Créer un client",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You don't have permissions to manage clients",
          "clearFilter_one": "Effacer le filtre",
          "clearFilter_other": "Effacer les filtres",
          "description": "Créez un client pour organiser et gérer son travail.",
          "filterDoesNotMatchClient_one": "Le filtre ne correspond à aucun client",
          "filterDoesNotMatchClient_other": "Les filtres ne correspondent à aucun client",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "Aucun client créé pour le moment"
        },
        "recentlyDeleted": {
          "description": "Nous conserverons les clients récemment supprimés ici pendant {{days}} jours.",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "Restaurer",
            "confirmMessageFirst": "Êtes-vous sûr de vouloir supprimer le client {{clientName}} ?",
            "confirmMessageSecond": "Tous les utilisateurs du client auront à nouveau accès aux ressources du client.",
            "confirmModalTitle": "Restaurer le client",
            "errorMessage": "Impossible de restaurer le client",
            "successMessage": "Client restauré"
          },
          "table": {
            "columns": {
              "deletedBy": "Supprimé par",
              "deletedOn": "Supprimé le",
              "name": "Nom"
            }
          },
          "title": "Supprimés récemment"
        },
        "searchEmptyState": {
          "clearSearch": "Effacer la recherche",
          "description": "Nous n'avons pu trouver {<searchTerm>} dans aucun client.",
          "title": "Votre recherche ne correspond à aucun client"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "Nom",
          "primaryContact": {
            "label": "Contact principal",
            "no": "Non",
            "yes": "Oui"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "Personnes",
          "services": "Services"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "Contacts",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "Fichiers",
          "overview": "Aperçu",
          "projects": "Projets"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "Ajouter un contact",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "Ajouter",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "Annuler",
        "contactExistsError": "Un contact avec cette adresse e-mail existe déjà pour le client.",
        "create": "Créer",
        "createNewContactTitle": "Créer un contact",
        "createServices": "Créer des services pour le client.",
        "email": "E-mail",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "Impossible d'ajouter le contact",
        "errorMessage_other": "Impossible d'ajouter les contacts",
        "firstName": "Prénom",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "Nom de famille",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "Suivant",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "Contact ajouté",
        "successMessage_other": "Contacts ajoutés",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "Principale"
      },
      "contactsTab": {
        "actions": {
          "cancel": "Annuler",
          "confirm": "Confirmer",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "Gérer les utilisateurs",
          "remove": {
            "confirmModalTitle_one": "Supprimer le contact du client",
            "confirmModalTitle_other": "Supprimer les contacts du client",
            "confirmRemoveMessageFirst_one": "Êtes-vous sûr de vouloir supprimer ce contact du client ?",
            "confirmRemoveMessageFirst_other": "Êtes-vous sûr de vouloir supprimer ces contacts du client ?",
            "confirmRemoveMessageSecond": "Vous pourrez toujours les retrouver dans People.",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "Le contact n'a pas pu être supprimé",
            "errorMessage_other": "Impossible de supprimer les contacts",
            "label": "Supprimer",
            "removeOk": "Supprimer",
            "successMessage_one": "Contact supprimé",
            "successMessage_other": "Contacts supprimés"
          },
          "removePrimary": {
            "confirmButtonText": "Supprimer la désignation contact principal",
            "confirmModalTitle": "Supprimer la désignation contact principal",
            "confirmRemovePrimaryMessageFirst_one": "Êtes-vous sûr de vouloir supprimer la désignation du contact principal de cette personne ?",
            "confirmRemovePrimaryMessageFirst_other": "Êtes-vous sûr de vouloir supprimer la désignation du contact principal de ces personnes ?",
            "confirmRemovePrimaryMessageSecond_one": "Cette personne ne recevra plus de notifications concernant l'activité du client, mais demeurera parmi les contacts de ce client.",
            "confirmRemovePrimaryMessageSecond_other": "Ces personnes ne recevront plus de notifications concernant l'activité du client, mais demeureront parmi les contacts de ce client.",
            "errorMessage_one": "Le contact n'a pas pu être mis à jour",
            "errorMessage_other": "Impossible de mettre à jour les contacts",
            "label": "Supprimer la désignation du contact principal",
            "successMessage_one": "Coordonnées mises à jour",
            "successMessage_other": "Coordonnées mises à jour"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "Supprimer un membre de l'équipe du client",
            "confirmRemoveMessage": "Êtes-vous sûr de vouloir supprimer le contact {{contactName}} ?",
            "errorMessage": "Impossible de supprimer le membre de l'équipe",
            "removeOk": "Supprimer",
            "successMessage": "Membre de l'équipe supprimé"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "Supprimer la désignation contact principal",
            "confirmModalTitle": "Supprimer la désignation contact principal",
            "confirmRemovePrimaryMessage": "Êtes-vous sûr de vouloir supprimer la désignation du contact principal de l'équipe de cette personne ?",
            "errorMessage": "Impossible de mettre à jour le membre de l'équipe",
            "successMessage": "Membre de l'équipe mis à jour avec succès"
          },
          "setPrimary": {
            "confirmButtonText_one": "Désigner comme contact principal",
            "confirmButtonText_other": "Désigner comme contact principal",
            "confirmModalTitle_one": "Désigner comme contact principal",
            "confirmModalTitle_other": "Désigner comme contacts principaux",
            "confirmSetPrimaryMessageFirst_one": "Êtes-vous sûr de vouloir désigner cette personne comme contact principal de ce client ?",
            "confirmSetPrimaryMessageFirst_other": "Êtes-vous sûr de vouloir désigner ces personnes comme contacts principaux de ce client ?",
            "confirmSetPrimaryMessageSecond": "Les contacts principaux reçoivent des notifications sur l'activité des clients et sont affectés à toutes les nouvelles tâches client.",
            "errorMessage_one": "Impossible de définir le contact principal",
            "errorMessage_other": "Impossible de définir les contacts principaux",
            "label": "Désigner comme contact principal",
            "successMessage_one": "Coordonnées mises à jour",
            "successMessage_other": "Coordonnées mises à jour"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "Désigner le membre comme contact principal",
            "confirmModalTitle": "Désigner le membre comme contact principal",
            "confirmSetPrimaryMessage": "Êtes-vous sûr de vouloir désigner cette personne comme contact principal de l'équipe de ce client ?",
            "errorMessage": "Impossible de mettre à jour le membre de l'équipe",
            "successMessage": "Membre de l'équipe mis à jour avec succès"
          }
        },
        "email": "E-mail",
        "name": "Nom"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "Ajouter un contact",
        "addError": "Impossible d'ajouter des contacts",
        "addSuccessMessage": "Contact ajouté avec succès",
        "confirmAddClientInfo": "Êtes-vous sûr de vouloir ajouter {{contactName}} comme contact ?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "Le contact ne recevra pas de notification.",
        "sameDomainContactsMessage_one": "Un contact avec le même domaine de messagerie que le contact principal existe déjà.",
        "sameDomainContactsMessage_other": "{{count}} contacts avec le même domaine de messagerie que le contact principal existent déjà.",
        "selectSuggestedClient": "Select suggested contact",
        "title": "Contacts suggérés"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "Ajouter un contact",
        "addContacts_other": "Ajouter des contacts",
        "addSuccess_one": "Contact ajouté",
        "addSuccess_other": "Contacts ajoutés",
        "cancel": "Annuler",
        "emailField": "E-mail",
        "nameField": "Nom",
        "selectContactsInfoMessage": "Sélectionnez les contacts que vous souhaitez ajouter à ce client.",
        "title": "Ajouter les contacts suggérés"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "Spécifiez une adresse e-mail valide"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "Saisissez {{name}}"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "Aucun contact principal",
          "primaryContact": "(Principal)",
          "title": "Contacts",
          "viewAll": "Tout afficher"
        },
        "clientDetails": {
          "edit": "Modifier",
          "properties": {
            "clientId": "ID client",
            "clientType": "Type de client",
            "internalName": "Nom d'affichage"
          },
          "title": "Détails du client"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Join the service team to get access to all client requests, services, and files.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "Démarrez un service pour demander des fichiers ou des informations, envoyer des documents pour signature ou approbation.",
            "title": "Aucun travail n'a été créé pour ce client"
          },
          "title": "Demandes du client"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "Ajouter à l'équipe de service",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(Principal)",
          "remove": "Supprimer des contacts client",
          "removePrimaryDesignation": "Supprimer la désignation contact principal",
          "search": "Sélectionnez un ou plusieurs membres de l'équipe",
          "searchPlaceholder": "Rechercher par nom ou e-mail",
          "setPrimary": "Désigner le membre comme contact principal",
          "title": "Assigned team members",
          "viewAll": "Tout afficher"
        },
        "suggestedClients": {
          "title": "Clients suggérés"
        },
        "suggestedContacts": {
          "title": "Contacts suggérés",
          "viewAll": "Tout afficher"
        }
      }
    }
  },
  {
    "key": "it",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "Accedi",
        "message": "Ti riporteremo qui per consentirti di riprendere da dove eri rimasto.",
        "title": "Effettuare nuovamente l'accesso per accedere alla dashboard del cliente"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to a clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "Aggiungi",
        "addNewClient": "Aggiungi nuovo cliente",
        "cancel": "Annulla",
        "clientPermissionErrorMessage": "Solo i membri del team autorizzati per questo cliente possono eseguire questa operazione.",
        "editClientAssignmentTitle": "Modifica assegnazione cliente",
        "linkSuccessMessage": "Collegato correttamente al cliente",
        "linkToClient": "Collega al cliente",
        "linkedClient": "Linked client",
        "save": "Salva",
        "searchClientPlaceholder": "Seleziona un cliente",
        "successMessage": "Aggiunto correttamente al cliente",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for clients.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "Rinuncia all'accesso anticipato"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "Purtroppo al momento il tuo account non ha entità cliente abilitate.",
        "noConfigurationTitle": "Le nuove entità cliente verranno visualizzate qui."
      },
      "clientContactContextBar": {
        "more": "Altro",
        "noSelection": "Selezionare i contatti per vedere le azioni",
        "optionsMenu": "Open client contact options",
        "resetSelection": "Reimposta selezione",
        "selected": "Selezionato"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn’t seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "Cerca un nome o un indirizzo e-mail",
        "suggestionsLabel": "Persone suggerite"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "Per conto di",
        "isPrimary": "(Principale)",
        "missingClientValidationError": "Il contatto deve essere associato a un cliente",
        "missingContactValidationError": "La selezione del contatto è obbligatoria",
        "noClientEntity": "Questo contatto non è attualmente associato ad alcuna entità cliente. {<link>} affinché questo contatto possa procedere.",
        "noClientEntityLinkText": "Creare un'entità cliente",
        "notFound": "Nessun risultato trovato",
        "primaryContactMessage": "Contatto principale per {{clientEntityName}}",
        "primaryTeamMemberMessage": "Membro principale del team di {{clientEntityName}}",
        "singleClientMessage": "Contatto per {<clientNameLink>}",
        "singlePrimaryClientMessage": "Contatto principale per {<clientNameLink>}",
        "teamMemberMessage": "Membro del team di {{clientEntityName}}",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "Annulla",
            "confirmMessage_one": "Eliminare questo cliente? Alcune risorse del cliente non verranno eliminate.",
            "confirmMessage_other": "Eliminare questi clienti? Alcune risorse dei clienti non verranno eliminate.",
            "confirmModalTitle_one": "Elimina cliente",
            "confirmModalTitle_other": "Elimina clienti",
            "errorMessage_one": "Impossibile eliminare il cliente",
            "errorMessage_other": "Impossibile eliminare i clienti",
            "folders": "Cartelle",
            "foldersInfo": "I file e le cartelle collegati rimarranno in {<folders>}",
            "label_one": "Elimina cliente",
            "label_other": "Elimina clienti",
            "moreOptions": "Più opzioni",
            "people": "Persone",
            "peopleInfo": "I contatti rimarranno in {<people>}",
            "projects": "Progetti",
            "projectsInfo": "I progetti e le richieste del cliente rimarranno in {<projects>}",
            "restore": "È possibile ripristinare un cliente eliminato entro {<restoreDays>} tramite il menu {<moreOptions>}.",
            "restoreDays": "45 giorni",
            "solutionsInfo": "Le risorse delle soluzioni installate rimarranno nei dashboard delle soluzioni",
            "successMessage_one": "Cliente eliminato",
            "successMessage_other": "Clienti eliminati"
          },
          "dropdownLabel": "Actions",
          "editDetails": "Modifica dettagli"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "Reimposta selezione",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Gruppo clienti {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "Crea nuovo",
          "selectContactPlaceholder": "Ricerca per nome o e-mail",
          "title": "Dati di contatto principali"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "ID client già esistente; immettere un ID client univoco.",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "ID cliente (facoltativo)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "Nome interno già esistente; immettere un nome interno univoco.",
            "help": "Questo è visibile solo ai membri del team interno.",
            "label": "Nome visualizzato interno",
            "requiredError": "Il nome interno non può essere vuoto."
          },
          "title": "Dettagli del cliente"
        },
        "create": {
          "button": "Crea",
          "clientName": "Nome",
          "clientType": "Tipo di cliente",
          "createError": "Impossibile creare il cliente",
          "createdTitle": "Cliente creato",
          "ftuHelp": "Breve paragrafo o punti elenco che descrivono il valore della creazione di un'entità cliente. ",
          "title": "Crea nuovo cliente"
        },
        "createContact": {
          "duplicateError": "Questo contatto esiste già. Assegnare il contatto suggerito o inserire un indirizzo e-mail diverso."
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "Annulla",
        "clientNameLabel": "Nome",
        "submitLabel": "Salva",
        "successMessage": "Cliente aggiornato",
        "updateDrawerTitle": "Modifica i dettagli del cliente",
        "updateError": "Impossibile aggiornare il cliente"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "Tutto",
            "company": "Società",
            "individual": "Individuo",
            "showMyClientsLabel": "Mostra solo i miei clienti",
            "type": "Tipo di cliente"
          },
          "searchPlaceholder": "Cerca clienti",
          "sortLabel": "Ordina per",
          "sortOptions": {
            "createdAsc": "Meno recente",
            "createdDesc": "Più recente",
            "createdLabel": "Data di creazione",
            "nameAsc": "A - Z",
            "nameDesc": "Z - A",
            "nameLabel": "Nome"
          },
          "sortOrder": "Ordinamento"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "Impostazioni"
          },
          "create": "Crea cliente",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You don't have permissions to manage clients",
          "clearFilter_one": "Cancella filtro",
          "clearFilter_other": "Cancella filtri",
          "description": "Creare un cliente per organizzare e gestire il suo lavoro.",
          "filterDoesNotMatchClient_one": "Il filtro non trova corrispondenze in alcun cliente",
          "filterDoesNotMatchClient_other": "I filtri non trovano corrispondenze in alcun cliente",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "Non è stato ancora creato alcun cliente"
        },
        "recentlyDeleted": {
          "description": "I clienti eliminati di recente verranno memorizzati qui per {{days}} giorni.",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "Ripristina",
            "confirmMessageFirst": "Ripristinare {{clientName}}?",
            "confirmMessageSecond": "Tutti gli utenti del cliente riacquisteranno l'accesso alle risorse del cliente.",
            "confirmModalTitle": "Ripristina cliente",
            "errorMessage": "Impossibile ripristinare il cliente",
            "successMessage": "Cliente ripristinato"
          },
          "table": {
            "columns": {
              "deletedBy": "Eliminato da",
              "deletedOn": "Eliminati il",
              "name": "Nome"
            }
          },
          "title": "Eliminati di recente"
        },
        "searchEmptyState": {
          "clearSearch": "Cancella ricerca",
          "description": "Non siamo riusciti a trovare {<searchTerm>} in alcun cliente.",
          "title": "La ricerca non trova corrispondenze in alcun cliente"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "Nome",
          "primaryContact": {
            "label": "Contatto primario",
            "no": "No",
            "yes": "Sì"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "Persone",
          "services": "Servizi"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "Contatti",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "File",
          "overview": "Panoramica",
          "projects": "Progetti"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "Aggiungi contatto",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "Aggiungi",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "Annulla",
        "contactExistsError": "Nel cliente esiste già un contatto con questo indirizzo e-mail.",
        "create": "Crea",
        "createNewContactTitle": "Crea nuovo contatto",
        "createServices": "Creare servizi per il cliente.",
        "email": "E-mail",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "Impossibile aggiungere il contatto",
        "errorMessage_other": "Impossibile aggiungere i contatti",
        "firstName": "Nome",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "Cognome",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "Avanti",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "Contatto aggiunto",
        "successMessage_other": "Contatti aggiunti",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "Principale"
      },
      "contactsTab": {
        "actions": {
          "cancel": "Annulla",
          "confirm": "Conferma",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "Gestisci utente",
          "remove": {
            "confirmModalTitle_one": "Rimuovi il contatto dal cliente",
            "confirmModalTitle_other": "Rimuovi i contatti dal cliente",
            "confirmRemoveMessageFirst_one": "Rimuovere questo contatto da questo cliente?",
            "confirmRemoveMessageFirst_other": "Rimuovere questi contatti da questo cliente?",
            "confirmRemoveMessageSecond": "Sarà comunque possibile trovarli in Persone.",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "Impossibile rimuovere il contatto",
            "errorMessage_other": "Impossibile rimuovere i contatti",
            "label": "Rimuovi",
            "removeOk": "Rimuovi",
            "successMessage_one": "Contatto rimosso",
            "successMessage_other": "Contatti rimossi"
          },
          "removePrimary": {
            "confirmButtonText": "Rimuovi la designazione di principale",
            "confirmModalTitle": "Rimuovi la designazione di principale",
            "confirmRemovePrimaryMessageFirst_one": "Rimuovere la designazione di contatto principale di questa persona?",
            "confirmRemovePrimaryMessageFirst_other": "Rimuovere la designazione di contatto principale di queste persone?",
            "confirmRemovePrimaryMessageSecond_one": "Questa persona non riceverà più notifiche per l'attività del cliente, ma sarà comunque un contatto per questo cliente.",
            "confirmRemovePrimaryMessageSecond_other": "Non riceveranno più notifiche per l'attività del cliente, ma saranno comunque contatti per questo cliente.",
            "errorMessage_one": "Impossibile aggiornare il contatto",
            "errorMessage_other": "Impossibile aggiornare i contatti",
            "label": "Rimuovi la designazione di principale",
            "successMessage_one": "Dettagli del contatto aggiornati",
            "successMessage_other": "Dettagli dei contatti aggiornati"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "Rimuovi il membro del team dal cliente",
            "confirmRemoveMessage": "Rimuovere {{contactName}}?",
            "errorMessage": "Impossibile rimuovere il membro del team",
            "removeOk": "Rimuovi",
            "successMessage": "Membro del team rimosso"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "Rimuovi la designazione di principale",
            "confirmModalTitle": "Rimuovi la designazione di principale",
            "confirmRemovePrimaryMessage": "Rimuovere la designazione di membro primario del team di questa persona?",
            "errorMessage": "Impossibile aggiornare il membro del team",
            "successMessage": "Membro del team aggiornato correttamente"
          },
          "setPrimary": {
            "confirmButtonText_one": "Rendi contatto principale",
            "confirmButtonText_other": "Rendi contatti principali",
            "confirmModalTitle_one": "Rendi contatto principale",
            "confirmModalTitle_other": "Rendi contatti principali",
            "confirmSetPrimaryMessageFirst_one": "Rendere questa persona un contatto primario per questo cliente?",
            "confirmSetPrimaryMessageFirst_other": "Rendere queste persone i contatti principali per questo cliente?",
            "confirmSetPrimaryMessageSecond": "I contatti principali ricevono notifiche sull'attività del cliente e vengono assegnati a tutte le nuove attività del cliente.",
            "errorMessage_one": "Impossibile impostare il contatto principale",
            "errorMessage_other": "Impossibile impostare i contatti principali",
            "label": "Rendi contatto principale",
            "successMessage_one": "Dettagli del contatto aggiornati",
            "successMessage_other": "Dettagli dei contatti aggiornati"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "Rendi membro principale del team",
            "confirmModalTitle": "Rendi membro principale del team",
            "confirmSetPrimaryMessage": "Rendere questa persona un membro primario del team di questo cliente?",
            "errorMessage": "Impossibile aggiornare il membro del team",
            "successMessage": "Membro del team aggiornato correttamente"
          }
        },
        "email": "E-mail",
        "name": "Nome"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "Aggiungi contatto",
        "addError": "Impossibile aggiungere i contatti",
        "addSuccessMessage": "Contatto aggiunto correttamente",
        "confirmAddClientInfo": "Aggiungere {{contactName}} come contatto?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "Il contatto non verrà informato.",
        "sameDomainContactsMessage_one": "È presente 1 contatto con lo stesso dominio e-mail del contatto principale.",
        "sameDomainContactsMessage_other": "Sono presenti {{count}} contatti con lo stesso dominio e-mail del contatto principale.",
        "selectSuggestedClient": "Select suggested contact",
        "title": "Contatti consigliati"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "Aggiungi contatto",
        "addContacts_other": "Aggiungi contatti",
        "addSuccess_one": "Contatto aggiunto",
        "addSuccess_other": "Contatti aggiunti",
        "cancel": "Annulla",
        "emailField": "E-mail",
        "nameField": "Nome",
        "selectContactsInfoMessage": "Selezionare i contatti che si desidera aggiungere a questo cliente.",
        "title": "Aggiungi i contatti suggeriti"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "Fornire un indirizzo e-mail valido"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "Inserire {{name}}"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "Nessun contatto primario",
          "primaryContact": "(Principale)",
          "title": "Contatti",
          "viewAll": "Visualizza tutto"
        },
        "clientDetails": {
          "edit": "Modifica",
          "properties": {
            "clientId": "ID cliente",
            "clientType": "Tipo di cliente",
            "internalName": "Nome visualizzato"
          },
          "title": "Dettagli del cliente"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Join the service team to get access to all client requests, services, and files.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "Avviare un servizio per richiedere file o informazioni, inviare documenti per firme o approvazioni.",
            "title": "Non è stato creato alcun lavoro per questo cliente"
          },
          "title": "Richieste dei clienti"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "Aggiungi al team di servizio",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(Principale)",
          "remove": "Rimuovi dal cliente",
          "removePrimaryDesignation": "Rimuovi la designazione di principale",
          "search": "Seleziona uno o più membri del team",
          "searchPlaceholder": "Ricerca per nome o e-mail",
          "setPrimary": "Rendi membro principale del team",
          "title": "Assigned team members",
          "viewAll": "Visualizza tutto"
        },
        "suggestedClients": {
          "title": "Clienti suggeriti"
        },
        "suggestedContacts": {
          "title": "Contatti consigliati",
          "viewAll": "Visualizza tutto"
        }
      }
    }
  },
  {
    "key": "ja",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "サインイン",
        "message": "すぐにここに戻るので、中断したところから再開できます。",
        "title": "再度サインインしてクライアント ダッシュボードにアクセスします"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to a clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "追加",
        "addNewClient": "新しいクライアントを追加する",
        "cancel": "キャンセル",
        "clientPermissionErrorMessage": "このクライアントの承認されたチーム メンバーのみがこの操作を実行できます。",
        "editClientAssignmentTitle": "クライアントの割り当てを編集する",
        "linkSuccessMessage": "クライアントにリンクされました",
        "linkToClient": "クライアントにリンクする",
        "linkedClient": "Linked client",
        "save": "保存",
        "searchClientPlaceholder": "クライアントを選択する",
        "successMessage": "クライアントに追加されました",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for clients.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "早期アクセスのオプトアウト"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "残念ながら、現在ご利用中のアカウントではクライアント エンティティが有効になっていません。",
        "noConfigurationTitle": "新しいクライアント エンティティがここに表示されます。"
      },
      "clientContactContextBar": {
        "more": "詳細",
        "noSelection": "担当者を選択してアクションを表示する",
        "optionsMenu": "Open client contact options",
        "resetSelection": "選択をリセットする",
        "selected": "選択"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn’t seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "名前またはメール アドレスを検索する",
        "suggestionsLabel": "候補のユーザー"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "次の代理: ",
        "isPrimary": "(プライマリ)",
        "missingClientValidationError": "担当者はクライアントに関連付けられている必要があります",
        "missingContactValidationError": "担当者の選択が必要です",
        "noClientEntity": "この担当者は現在、どのクライアント エンティティにも関連付けられていません。この担当者で続行するには、{<link>} を実行します。",
        "noClientEntityLinkText": "クライアント エンティティを作成する",
        "notFound": "結果が見つかりませんでした",
        "primaryContactMessage": "{{clientEntityName}} の主な担当者",
        "primaryTeamMemberMessage": "{{clientEntityName}} の主なチーム メンバー",
        "singleClientMessage": "{<clientNameLink>} の担当者",
        "singlePrimaryClientMessage": "{<clientNameLink>} の主な担当者",
        "teamMemberMessage": "{{clientEntityName}} のチーム メンバー",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "キャンセル",
            "confirmMessage_one": "このクライアントを削除してもよろしいですか? 一部のクライアント リソースは削除されません。",
            "confirmMessage_other": "これらのクライアントを削除してもよろしいですか? 一部のクライアント リソースは削除されません。",
            "confirmModalTitle_one": "クライアントの削除",
            "confirmModalTitle_other": "クライアントの削除",
            "errorMessage_one": "クライアントを削除できませんでした",
            "errorMessage_other": "クライアントを削除できませんでした",
            "folders": "フォルダー",
            "foldersInfo": "リンクされたファイルとフォルダーは {<folders>} に残ります",
            "label_one": "クライアントの削除",
            "label_other": "クライアントの削除",
            "moreOptions": "その他のオプション",
            "people": "ユーザー",
            "peopleInfo": "担当者は {<people>} に残ります",
            "projects": "プロジェクト",
            "projectsInfo": "プロジェクトとクライアントのリクエストは {<projects>} に残ります",
            "restore": "削除したクライアントは {<moreOptions>} メニューから {<restoreDays>} 日内に復元できます。",
            "restoreDays": "45日",
            "solutionsInfo": "インストールされたソリューションのリソースはソリューション ダッシュボードに残ります",
            "successMessage_one": "クライアントが削除されました",
            "successMessage_other": "複数クライアントが削除されました"
          },
          "dropdownLabel": "Actions",
          "editDetails": "詳細を編集する"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "選択をリセットする",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Client group {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "新規作成",
          "selectContactPlaceholder": "名前またはメールで検索",
          "title": "主な担当者の詳細"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "クライアント ID が既に存在します。一意のクライアント ID を入力してください。",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "クライアント シークレット (オプション)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "内部名が既に存在します。一意の内部名を入力してください。",
            "help": "これは内部チーム メンバーにのみ表示されます。",
            "label": "内部の表示名",
            "requiredError": "内部名は空にできません。"
          },
          "title": "クライアントの詳細"
        },
        "create": {
          "button": "作成",
          "clientName": "名前",
          "clientType": "クライアントの種類",
          "createError": "クライアントを作成できませんでした",
          "createdTitle": "作成済みクライアント",
          "ftuHelp": "クライアント エンティティを作成する価値を説明する短い段落または箇条書き。 ",
          "title": "新しいクライアントを作成する"
        },
        "createContact": {
          "duplicateError": "この担当者は既に存在します。提案された担当者を割り当てるか、別のメール アドレスを入力してください。"
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "キャンセル",
        "clientNameLabel": "名前",
        "submitLabel": "保存",
        "successMessage": "クライアントが更新されました",
        "updateDrawerTitle": "クライアントの詳細を編集する",
        "updateError": "クライアントを更新できませんでした"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "すべて",
            "company": "会社",
            "individual": "個別",
            "showMyClientsLabel": "自分のクライアントのみを表示する",
            "type": "クライアントの種類"
          },
          "searchPlaceholder": "クライアントを検索する",
          "sortLabel": "並べ替え基準",
          "sortOptions": {
            "createdAsc": "古い順",
            "createdDesc": "新しい順",
            "createdLabel": "作成日時",
            "nameAsc": "A～Z",
            "nameDesc": "Z～A",
            "nameLabel": "名前"
          },
          "sortOrder": "並べ替え順"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "設定"
          },
          "create": "クライアントを作成する",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You don't have permissions to manage clients",
          "clearFilter_one": "フィルターをクリアする",
          "clearFilter_other": "フィルターをクリア",
          "description": "クライアントを作成して、作業を整理および管理します。",
          "filterDoesNotMatchClient_one": "フィルターはどのクライアントにも一致しません",
          "filterDoesNotMatchClient_other": "フィルターはどのクライアントにも一致しません",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "クライアントはまだ作成されていません"
        },
        "recentlyDeleted": {
          "description": "最近削除済みのクライアントはここに {{days}} 日間保存されます。",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "復元",
            "confirmMessageFirst": "{{clientName}} を復元してもよろしいですか?",
            "confirmMessageSecond": "クライアントの全員がクライアント リソースに再びアクセスできるようになります。",
            "confirmModalTitle": "クライアントを復元する",
            "errorMessage": "クライアントを復元できませんでした",
            "successMessage": "復元されたクライアント"
          },
          "table": {
            "columns": {
              "deletedBy": "削除の実行者",
              "deletedOn": "削除した日:",
              "name": "名前"
            }
          },
          "title": "最近削除済み"
        },
        "searchEmptyState": {
          "clearSearch": "検索をクリア",
          "description": "どのクライアントにも {<searchTerm>} が見つかりませんでした。",
          "title": "検索条件に一致するクライアントはありません"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "名前",
          "primaryContact": {
            "label": "主な担当者",
            "no": "いいえ",
            "yes": "はい"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "ユーザー",
          "services": "Services"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "連絡先",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "ファイル",
          "overview": "概要",
          "projects": "プロジェクト"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "連絡先を追加",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "追加",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "キャンセル",
        "contactExistsError": "このメールの担当者は既にクライアントに存在します。",
        "create": "作成",
        "createNewContactTitle": "新しい連絡先を作成",
        "createServices": "クライアントのサービスを作成します。",
        "email": "メール",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "担当者を追加できませんでした",
        "errorMessage_other": "担当者を追加できませんでした",
        "firstName": "名",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "姓",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "次へ",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "担当者が追加されました",
        "successMessage_other": "担当者が追加されました",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "プライマリ"
      },
      "contactsTab": {
        "actions": {
          "cancel": "キャンセル",
          "confirm": "確認",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "ユーザーを管理する",
          "remove": {
            "confirmModalTitle_one": "クライアントから担当者を削除する",
            "confirmModalTitle_other": "クライアントから担当者を削除する",
            "confirmRemoveMessageFirst_one": "この担当者をこのクライアントから削除してもよろしいですか?",
            "confirmRemoveMessageFirst_other": "これらの担当者をこのクライアントから削除してもよろしいですか?",
            "confirmRemoveMessageSecond": "引き続き彼らを [ユーザー] で見つけることができます。",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "担当者を削除できません",
            "errorMessage_other": "複数の担当者を削除できません",
            "label": "削除",
            "removeOk": "削除",
            "successMessage_one": "担当者が削除されました",
            "successMessage_other": "複数の担当者が削除されました"
          },
          "removePrimary": {
            "confirmButtonText": "主な指定を削除する",
            "confirmModalTitle": "主な指定を削除する",
            "confirmRemovePrimaryMessageFirst_one": "このユーザーの主な担当者の指定を削除してもよろしいですか?",
            "confirmRemovePrimaryMessageFirst_other": "これらのユーザーの主な担当者の指定を削除してもよろしいですか?",
            "confirmRemovePrimaryMessageSecond_one": "このユーザーは、クライアントのアクティビティに関する通知を受け取ることはなくなりますが、このクライアントの担当者のままです。",
            "confirmRemovePrimaryMessageSecond_other": "これらのユーザーは、クライアントのアクティビティに関する通知を受け取ることはなくなりますが、このクライアントの担当者のままです。",
            "errorMessage_one": "担当者を更新できません",
            "errorMessage_other": "複数の担当者を更新できません",
            "label": "主な指定を削除する",
            "successMessage_one": "担当者の詳細が更新されました",
            "successMessage_other": "複数の担当者の詳細が更新されました"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "クライアントからチーム メンバーを削除する",
            "confirmRemoveMessage": "{{contactName}} を削除してもよろしいですか?",
            "errorMessage": "チーム メンバーを削除できません",
            "removeOk": "削除",
            "successMessage": "チーム メンバーを削除しました"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "主な指定を削除する",
            "confirmModalTitle": "主な指定を削除する",
            "confirmRemovePrimaryMessage": "このユーザーの主なチーム メンバーの指定を削除してもよろしいですか?",
            "errorMessage": "チーム メンバーを削除できません",
            "successMessage": "チーム メンバーが更新されました"
          },
          "setPrimary": {
            "confirmButtonText_one": "主な担当者にする",
            "confirmButtonText_other": "主な担当者にする",
            "confirmModalTitle_one": "主な担当者にする",
            "confirmModalTitle_other": "主な担当者にする",
            "confirmSetPrimaryMessageFirst_one": "このユーザーをこのクライアントの主な担当者にしてもよろしいですか?",
            "confirmSetPrimaryMessageFirst_other": "これらのユーザーをこのクライアントの主な担当者にしてもよろしいですか?",
            "confirmSetPrimaryMessageSecond": "主な担当者はクライアントのアクティビティに関する通知を受け取り、クライアントのすべての新しいタスクに割り当てられます。",
            "errorMessage_one": "主な担当者を設定できません",
            "errorMessage_other": "複数の主な担当者を設定できません",
            "label": "主な担当者にする",
            "successMessage_one": "担当者の詳細が更新されました",
            "successMessage_other": "複数の担当者の詳細が更新されました"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "主なチーム メンバーにする",
            "confirmModalTitle": "主なチーム メンバーにする",
            "confirmSetPrimaryMessage": "このユーザーをこのクライアントの主なチーム メンバーにしてもよろしいですか?",
            "errorMessage": "チーム メンバーを削除できません",
            "successMessage": "チーム メンバーが更新されました"
          }
        },
        "email": "メール",
        "name": "名前"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "連絡先を追加",
        "addError": "複数の担当者を追加できません",
        "addSuccessMessage": "担当者が追加されました",
        "confirmAddClientInfo": "{{contactName}} を主な担当者として追加してもよろしいですか?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "担当者には通知されません。",
        "sameDomainContactsMessage_one": "主な担当者と同じメール ドメインの担当者が 1 件存在します。",
        "sameDomainContactsMessage_other": "主な担当者と同じメール ドメインの担当者が {{count}} 件存在します。",
        "selectSuggestedClient": "Select suggested contact",
        "title": "連絡先候補"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "連絡先を追加",
        "addContacts_other": "連絡先の追加",
        "addSuccess_one": "担当者が追加されました",
        "addSuccess_other": "担当者が追加されました",
        "cancel": "キャンセル",
        "emailField": "メール",
        "nameField": "名前",
        "selectContactsInfoMessage": "このクライアントに追加する担当者を選択します。",
        "title": "担当者候補を追加する"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "有効なメールアドレスを提供してください"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "{{name}} を入力してください"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "主な担当者がありません",
          "primaryContact": "(プライマリ)",
          "title": "連絡先",
          "viewAll": "すべてを表示する"
        },
        "clientDetails": {
          "edit": "編集",
          "properties": {
            "clientId": "クライアントID",
            "clientType": "クライアントの種類",
            "internalName": "表示名"
          },
          "title": "クライアントの詳細"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Join the service team to get access to all client requests, services, and files.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "ファイルや情報をリクエストするサービスを開始したり、署名や承認のためにドキュメントを送信したりします。",
            "title": "このクライアントの作業は作成されていません"
          },
          "title": "クライアント リクエスト"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "サービス チームに追加する",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(プライマリ)",
          "remove": "クライアントから削除する",
          "removePrimaryDesignation": "主な指定を削除する",
          "search": "1 人または複数のチーム メンバーを選択する",
          "searchPlaceholder": "名前またはメールで検索",
          "setPrimary": "主なチーム メンバーにする",
          "title": "Assigned team members",
          "viewAll": "すべてを表示する"
        },
        "suggestedClients": {
          "title": "クライアント候補"
        },
        "suggestedContacts": {
          "title": "連絡先候補",
          "viewAll": "すべてを表示する"
        }
      }
    }
  },
  {
    "key": "nl",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "Aanmelden",
        "message": "U wordt zo naar hier teruggeleid, zodat u verder kunt gaan waar u was gebleven.",
        "title": "Meld u opnieuw aan om toegang te krijgen tot uw klantdashboard"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to a clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "Toevoegen",
        "addNewClient": "Nieuwe klant toevoegen",
        "cancel": "Annuleren",
        "clientPermissionErrorMessage": "Alleen geautoriseerde teamleden voor deze klant mogen deze bewerking uitvoeren.",
        "editClientAssignmentTitle": "Klanttoewijzing bewerken",
        "linkSuccessMessage": "Gekoppeld aan klant",
        "linkToClient": "Link naar klant",
        "linkedClient": "Linked client",
        "save": "Opslaan",
        "searchClientPlaceholder": "Selecteer een klant",
        "successMessage": "Toegevoegd aan klant",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for clients.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "Afmelden voor vroege toegang"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "Helaas zijn er momenteel geen klantentiteiten ingeschakeld voor uw account.",
        "noConfigurationTitle": "De nieuwe klantentiteiten worden hier weergegeven."
      },
      "clientContactContextBar": {
        "more": "Meer",
        "noSelection": "Selecteer contacten om acties te zien",
        "optionsMenu": "Open client contact options",
        "resetSelection": "Selectie opnieuw instellen",
        "selected": "Geselecteerd"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn’t seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "Zoek naar een naam of e-mailadres",
        "suggestionsLabel": "Voorgestelde personen"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "Namens",
        "isPrimary": "(Primair)",
        "missingClientValidationError": "De contactpersoon moet gekoppeld zijn aan een klant",
        "missingContactValidationError": "Selecteren van contactpersoon is vereist",
        "noClientEntity": "Deze contactpersoon is momenteel niet aan een klantentiteit gekoppeld. {<link>} om deze contactpersoon te laten doorgaan.",
        "noClientEntityLinkText": "Een klantentiteit aanmaken",
        "notFound": "Geen resultaten gevonden",
        "primaryContactMessage": "Primaire contactpersoon voor {{clientEntityName}}",
        "primaryTeamMemberMessage": "Primair teamlid voor {{clientEntityName}}",
        "singleClientMessage": "Contactpersoon voor {<clientNameLink>}",
        "singlePrimaryClientMessage": "Primaire contactpersoon voor {<clientNameLink>}",
        "teamMemberMessage": "Teamlid voor {{clientEntityName}}",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "Annuleren",
            "confirmMessage_one": "Weet u zeker dat u deze klant wilt verwijderen? Sommige bronnen van de klant worden niet verwijderd.",
            "confirmMessage_other": "Weet u zeker dat u deze klanten wilt verwijderen? Sommige bronnen van de klanten worden niet verwijderd.",
            "confirmModalTitle_one": "Klant verwijderen",
            "confirmModalTitle_other": "Klanten verwijderen",
            "errorMessage_one": "Kan klant niet verwijderen",
            "errorMessage_other": "Kan klanten niet verwijderen",
            "folders": "Mappen",
            "foldersInfo": "Gekoppelde bestanden en mappen blijven in {<folders>}",
            "label_one": "Klant verwijderen",
            "label_other": "Klanten verwijderen",
            "moreOptions": "Meer opties",
            "people": "Personen",
            "peopleInfo": "Contacten blijven in {<people>}",
            "projects": "Projecten",
            "projectsInfo": "Projecten en klantaanvragen blijven in {<projects>}",
            "restore": "U kunt een verwijderde klant herstellen binnen {<restoreDays>} via het {<moreOptions>} menu.",
            "restoreDays": "45 dagen",
            "solutionsInfo": "Bronnen van geïnstalleerde oplossingen blijven in oplossingsdashboards staan",
            "successMessage_one": "Klant verwijderd",
            "successMessage_other": "Klanten verwijderd"
          },
          "dropdownLabel": "Actions",
          "editDetails": "Gegevens bewerken"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "Selectie opnieuw instellen",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Klantgroep {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "Nieuwe maken",
          "selectContactPlaceholder": "Zoeken op naam of e-mail",
          "title": "Gegevens primair contact"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "Klant-ID bestaat al, voer een unieke klant-ID in.",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "Klant-ID (optioneel)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "Interne naam bestaat al, voer een unieke interne naam in.",
            "help": "Dit is alleen zichtbaar voor interne teamleden.",
            "label": "Interne weergavenaam",
            "requiredError": "Interne naam mag niet leeg zijn."
          },
          "title": "Klantgegevens"
        },
        "create": {
          "button": "Maken",
          "clientName": "Naam",
          "clientType": "Clienttype",
          "createError": "Kan klant niet maken",
          "createdTitle": "Geregistreerde klant",
          "ftuHelp": "Korte alinea of opsommingstekens waarin de waarde wordt beschreven van het maken van een cliententiteit. ",
          "title": "Nieuwe klant maken"
        },
        "createContact": {
          "duplicateError": "Dit contact bestaat al. Wijs een voorgesteld contact toe of voer een ander e-mailadres in."
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "Annuleren",
        "clientNameLabel": "Naam",
        "submitLabel": "Opslaan",
        "successMessage": "Bijgewerkte klant",
        "updateDrawerTitle": "Klantgegevens bewerken",
        "updateError": "Kan klant niet bijwerken"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "Alle",
            "company": "Bedrijf",
            "individual": "Individueel",
            "showMyClientsLabel": "Alleen mijn klanten weergeven",
            "type": "Clienttype"
          },
          "searchPlaceholder": "Klanten zoeken",
          "sortLabel": "Sorteren op",
          "sortOptions": {
            "createdAsc": "Oudste",
            "createdDesc": "Nieuwste",
            "createdLabel": "Aanmaakdatum",
            "nameAsc": "A - Z",
            "nameDesc": "Z - A",
            "nameLabel": "Naam"
          },
          "sortOrder": "Sorteervolgorde"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "Instellingen"
          },
          "create": "Klant maken",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You don't have permissions to manage clients",
          "clearFilter_one": "Filter wissen",
          "clearFilter_other": "Filters wissen",
          "description": "Maak een client aan om diens werk te organiseren en te beheren.",
          "filterDoesNotMatchClient_one": "Het filter komt niet overeen met een client",
          "filterDoesNotMatchClient_other": "De filters komen niet overeen met een client",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "Nog geen clients aangemaakt"
        },
        "recentlyDeleted": {
          "description": "We bewaren recent verwijderde klanten hier voor {{days}} dagen.",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "Herstellen",
            "confirmMessageFirst": "Weet u zeker dat u {{clientName}} wilt herstellen?",
            "confirmMessageSecond": "Iedereen op de klant krijgt weer toegang tot de bronnen van de klant.",
            "confirmModalTitle": "Klant herstellen",
            "errorMessage": "Kan klant niet herstellen",
            "successMessage": "Herstelde klant"
          },
          "table": {
            "columns": {
              "deletedBy": "Verwijderd door",
              "deletedOn": "Verwijderd op",
              "name": "Naam"
            }
          },
          "title": "Recent verwijderd"
        },
        "searchEmptyState": {
          "clearSearch": "Zoekopdracht wissen",
          "description": "We konden {<searchTerm>} in geen enkele client vinden.",
          "title": "Uw zoekopdracht komt niet overeen met een client"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "Naam",
          "primaryContact": {
            "label": "Primair contact",
            "no": "Nee",
            "yes": "Ja"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "Personen",
          "services": "Services"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "Contacten",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "Bestanden",
          "overview": "Overzicht",
          "projects": "Projecten"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "Contactpersoon toevoegen",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "Toevoegen",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "Annuleren",
        "contactExistsError": "Er bestaat al een contactpersoon met dit e-mailadres in de klant.",
        "create": "Maken",
        "createNewContactTitle": "Nieuwe contactpersoon maken",
        "createServices": "Creëer services voor de klant.",
        "email": "E-mail",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "Kan contactpersoon niet toevoegen",
        "errorMessage_other": "Kan contactpersonen niet toevoegen",
        "firstName": "Voornaam",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "Achternaam",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "Volgende",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "Contactpersoon toegevoegd",
        "successMessage_other": "Contactpersonen toegevoegd",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "Primair"
      },
      "contactsTab": {
        "actions": {
          "cancel": "Annuleren",
          "confirm": "Bevestigen",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "Gebruiker beheren",
          "remove": {
            "confirmModalTitle_one": "Contactpersoon verwijderen van klant",
            "confirmModalTitle_other": "Contactpersonen verwijderen van klant",
            "confirmRemoveMessageFirst_one": "Weet u zeker dat u deze contactpersoon van deze klant wilt verwijderen?",
            "confirmRemoveMessageFirst_other": "Weet u zeker dat u deze contactpersonen van deze klant wilt verwijderen?",
            "confirmRemoveMessageSecond": "U kunt ze nog altijd vinden in Personen.",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "Contact kan niet worden verwijderd",
            "errorMessage_other": "Kan contactpersonen niet verwijderen",
            "label": "Verwijderen",
            "removeOk": "Verwijderen",
            "successMessage_one": "Contactpersoon verwijderd",
            "successMessage_other": "Contactpersonen verwijderd"
          },
          "removePrimary": {
            "confirmButtonText": "Primaire aanduiding verwijderen",
            "confirmModalTitle": "Primaire aanduiding verwijderen",
            "confirmRemovePrimaryMessageFirst_one": "Weet u zeker dat u de aanduiding van primaire contactpersoon van deze persoon wilt verwijderen?",
            "confirmRemovePrimaryMessageFirst_other": "Weet u zeker dat u de aanduiding van primaire contactpersoon van deze personen wilt verwijderen?",
            "confirmRemovePrimaryMessageSecond_one": "Deze persoon ontvangt geen meldingen meer over klantactiviteiten, maar blijft een contactpersoon voor deze klant.",
            "confirmRemovePrimaryMessageSecond_other": "Ze ontvangen geen meldingen meer over klantactiviteiten, maar blijven contactpersonen voor deze klant.",
            "errorMessage_one": "Contact kan niet worden bijgewerkt",
            "errorMessage_other": "Kan contactpersonen niet bijwerken",
            "label": "Primaire aanduiding verwijderen",
            "successMessage_one": "Bijgewerkte contactgegevens",
            "successMessage_other": "Bijgewerkte contactgegevens"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "Teamlid verwijderen van klant",
            "confirmRemoveMessage": "Weet u zeker dat u {{contactName}} wilt verwijderen?",
            "errorMessage": "Kan teamlid niet verwijderen",
            "removeOk": "Verwijderen",
            "successMessage": "Teamlid verwijderd"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "Primaire aanduiding verwijderen",
            "confirmModalTitle": "Primaire aanduiding verwijderen",
            "confirmRemovePrimaryMessage": "Weet u zeker dat u de aanduiding van primair teamlid van deze persoon wilt verwijderen?",
            "errorMessage": "Kan teamlid niet updaten",
            "successMessage": "Teamlid geüpdatet"
          },
          "setPrimary": {
            "confirmButtonText_one": "Primair contact maken",
            "confirmButtonText_other": "Primaire contacten maken",
            "confirmModalTitle_one": "Primair contact maken",
            "confirmModalTitle_other": "Primaire contacten maken",
            "confirmSetPrimaryMessageFirst_one": "Weet u zeker dat u deze persoon als primaire contactpersoon wilt aanduiden voor deze klant?",
            "confirmSetPrimaryMessageFirst_other": "Weet u zeker dat u deze personen als primaire contactpersonen wilt aanduiden voor deze klant?",
            "confirmSetPrimaryMessageSecond": "Primaire contactpersonen ontvangen meldingen over klantactiviteiten en worden toegewezen aan alle nieuwe klanttaken.",
            "errorMessage_one": "Primaire contactpersoon kan niet worden ingesteld",
            "errorMessage_other": "Primaire contactpersonen kunnen niet worden ingesteld",
            "label": "Primair contact maken",
            "successMessage_one": "Bijgewerkte contactgegevens",
            "successMessage_other": "Bijgewerkte contactgegevens"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "Primair teamlid maken",
            "confirmModalTitle": "Primair teamlid maken",
            "confirmSetPrimaryMessage": "Weet u zeker dat u deze persoon als primair teamlid wilt aanduiden voor deze klant?",
            "errorMessage": "Kan teamlid niet updaten",
            "successMessage": "Teamlid geüpdatet"
          }
        },
        "email": "E-mail",
        "name": "Naam"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "Contactpersoon toevoegen",
        "addError": "Kan contactpersonen niet toevoegen",
        "addSuccessMessage": "Contact is toegevoegd",
        "confirmAddClientInfo": "Weet u zeker dat u {{contactName}} als contact wilt toevoegen?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "De contactpersoon wordt niet op de hoogte gesteld.",
        "sameDomainContactsMessage_one": "Er is 1 contactpersoon met hetzelfde e-maildomein als de primaire contactpersoon.",
        "sameDomainContactsMessage_other": "Er zijn {{count}} contactpersonen met hetzelfde e-maildomein als de primaire contactpersoon.",
        "selectSuggestedClient": "Select suggested contact",
        "title": "Voorgestelde contactpersonen"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "Contactpersoon toevoegen",
        "addContacts_other": "Contactpersonen toevoegen",
        "addSuccess_one": "Contactpersoon toegevoegd",
        "addSuccess_other": "Contactpersonen toegevoegd",
        "cancel": "Annuleren",
        "emailField": "E-mail",
        "nameField": "Naam",
        "selectContactsInfoMessage": "Selecteer de contactpersonen die u aan deze klant wilt toevoegen.",
        "title": "Voorgestelde contactpersonen toevoegen"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "Voer een geldig e-mailadres in"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "Voer {{name}} in"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "Geen primaire contacten",
          "primaryContact": "(Primair)",
          "title": "Contacten",
          "viewAll": "Alles weergeven"
        },
        "clientDetails": {
          "edit": "Bewerken",
          "properties": {
            "clientId": "Klant-id",
            "clientType": "Clienttype",
            "internalName": "Weergavenaam"
          },
          "title": "Klantgegevens"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Join the service team to get access to all client requests, services, and files.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "Start een service om bestanden of informatie aan te vragen, documenten ter ondertekening of goedkeuring te verzenden.",
            "title": "Er is geen werk gemaakt voor deze klant"
          },
          "title": "Klantaanvragen"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "Toevoegen aan het serviceteam",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(Primair)",
          "remove": "Verwijderen van klant",
          "removePrimaryDesignation": "Primaire aanduiding verwijderen",
          "search": "Selecteer een of meerdere teamleden",
          "searchPlaceholder": "Zoeken op naam of e-mail",
          "setPrimary": "Primair teamlid maken",
          "title": "Assigned team members",
          "viewAll": "Alles weergeven"
        },
        "suggestedClients": {
          "title": "Voorgestelde klanten"
        },
        "suggestedContacts": {
          "title": "Voorgestelde contactpersonen",
          "viewAll": "Alles weergeven"
        }
      }
    }
  },
  {
    "key": "pt-BR",
    "content": {
      "LegacyTokenInterceptor": {
        "buttonText": "Fazer logon",
        "message": "Vamos trazê-lo de volta aqui para que você possa continuar de onde parou.",
        "title": "Faça logon novamente para acessar o painel do seu cliente"
      },
      "adminSettings": {
        "custom_fields": "Custom fields",
        "service_teams": "Service teams"
      },
      "clientAssociateFolder": {
        "linkToClient": "Link to client",
        "linkedClientFailureMessage_one": "Failed to link folder to a client",
        "linkedClientFailureMessage_other": "Failed to link folder to clients",
        "linkedClientSuccessMessage_one": "Linked folder to a client",
        "linkedClientSuccessMessage_other": "Linked folder to a clients",
        "linkedClients": "Linked clients",
        "save": "Save",
        "unlinkInfoAlert": "To unlink a client, go to their client page and remove this folder.",
        "updatedLinkedClientsFailureMessage": "Failed to update linked clients",
        "updatedLinkedClientsSuccessMessage": "Updated linked clients"
      },
      "clientAssociateResources": {
        "add": "Adicionar",
        "addNewClient": "Adicionar novo cliente",
        "cancel": "Cancelar",
        "clientPermissionErrorMessage": "Somente membros autorizados da equipe deste cliente estão autorizados a realizar esta operação.",
        "editClientAssignmentTitle": "Editar atribuição do cliente",
        "linkSuccessMessage": "Vinculado ao cliente com êxito",
        "linkToClient": "Vincular ao cliente",
        "linkedClient": "Linked client",
        "save": "Salvar",
        "searchClientPlaceholder": "Selecione um cliente",
        "successMessage": "Adicionado ao cliente com êxito",
        "unlink": {
          "cancelText": "Cancel",
          "confirmMessageFirst": "Are you sure you want to unlink the client from this project?",
          "confirmMessageSecond": "Once unlinked, the project will no longer be visible from the client's view. It will only be accessible through {<projects>}.",
          "confirmTitle": "Unlink client",
          "errorMessage": "Failed to unlink client",
          "okText": "Unlink",
          "successMessage": "Unlinked client"
        }
      },
      "clientConfiguration": {
        "customFields": {
          "actions": {
            "delete": {
              "acknowledge": "I acknowledge the data entered in this field will be lost.",
              "error": "Failed to delete custom field",
              "message": "Are you sure you want to delete the custom field {<fieldName>}",
              "success": "Deleted custom field",
              "title": "Delete"
            },
            "edit": {
              "dropdownWarning": "If a client or contact had a selection for an updated option, the current selection will remain until a new one is chosen from the dropdown.",
              "error": "Failed to update custom field",
              "success": "Updated custom field",
              "title": "Edit"
            }
          },
          "addCustomFieldButton": "Add custom field",
          "clientHubDisabledBanner": "Client hub is currently disabled. Custom fields will only be available when it’s enabled.",
          "clientsTab": "Clients",
          "contactsTab": "Contacts",
          "createButton": "Create custom field",
          "emptyState": {
            "clients": "clients",
            "contacts": "contacts",
            "subtitle": "Start by creating a custom field for clients.",
            "title": "No custom fields created yet"
          },
          "header": {
            "description": "Create custom fields for information that will be used across all clients or contacts.",
            "title": "Client custom fields"
          },
          "manage": "Manage custom fields",
          "table": {
            "columns": {
              "clientType": "Client type",
              "fieldType": "Field type",
              "key": "Field key",
              "name": "Name"
            }
          },
          "title": "Custom fields",
          "types": {
            "dropdown": "Dropdown list",
            "text": "Text"
          }
        },
        "eap": {
          "optout": "Desativar o acesso antecipado"
        },
        "manageAccess": "Manage client hub access",
        "noConfigurationDescription": "Infelizmente sua conta não tem entidades de cliente ativadas no momento.",
        "noConfigurationTitle": "As novas entidades de cliente aparecerão aqui."
      },
      "clientContactContextBar": {
        "more": "Mais",
        "noSelection": "Selecione os contatos para ver as ações",
        "optionsMenu": "Open client contact options",
        "resetSelection": "Redefinir seleção",
        "selected": "Selecionado(s)"
      },
      "clientContactInformation": {
        "contactInfo": {
          "address1": "Address 1",
          "address2": "Address 2",
          "city": "City/Town",
          "country": "Country",
          "phone": "Phone",
          "state": "State/Province/Region",
          "zip": "Postal/Zip code"
        },
        "customAttributes": {
          "title": "Client-specific details"
        },
        "emailValidation": {
          "emailRequiredError": "Please enter a valid email address",
          "emailValidationError": "This doesn’t seem to be a valid email address"
        },
        "personalInformation": {
          "email": "Email",
          "firstName": "First name",
          "lastName": "Last name"
        },
        "title": "Personal information"
      },
      "clientContactSelector": {
        "placeholder": "Pesquisar um nome ou endereço de email",
        "suggestionsLabel": "Pessoas sugeridas"
      },
      "clientContactUpdate": {
        "cancel": "Cancel",
        "drawerTitle": "Edit contact details",
        "errorMessage": "Failed to update contact",
        "save": "Save",
        "successMessage": "Updated contact details"
      },
      "clientContactUserInput": {
        "clientOptionsLabel": "Em nome de",
        "isPrimary": "(Principal)",
        "missingClientValidationError": "O contato deve estar associado a um cliente",
        "missingContactValidationError": "A seleção de contato é obrigatória",
        "noClientEntity": "No momento, esse contato não está associado a nenhuma entidade cliente. {<link>} para que esse contato continue.",
        "noClientEntityLinkText": "Criar uma entidade cliente",
        "notFound": "Nenhum resultado encontrado",
        "primaryContactMessage": "Contato principal para {{clientEntityName}}",
        "primaryTeamMemberMessage": "Membro principal da equipe para {{clientEntityName}}",
        "singleClientMessage": "Contato para {<clientNameLink>}",
        "singlePrimaryClientMessage": "Contato principal para {<clientNameLink>}",
        "teamMemberMessage": "Membro da equipe para {{clientEntityName}}",
        "userGroupMembers_one": "{{count}} user",
        "userGroupMembers_other": "{{count}} users"
      },
      "clientContextBar": {
        "actions": {
          "addTeamMembers": {
            "label": "Add team members"
          },
          "createNew": "Create new",
          "delete": {
            "cancel": "Cancelar",
            "confirmMessage_one": "Tem certeza de que deseja excluir este cliente? Alguns recursos do cliente não serão excluídos.",
            "confirmMessage_other": "Tem certeza de que deseja excluir estes clientes? Alguns recursos de cliente não serão excluídos.",
            "confirmModalTitle_one": "Excluir cliente",
            "confirmModalTitle_other": "Excluir clientes",
            "errorMessage_one": "Falha ao excluir o cliente",
            "errorMessage_other": "Falha ao excluir clientes",
            "folders": "Pastas",
            "foldersInfo": "Os arquivos e pastas vinculados permanecerão em {<folders>}",
            "label_one": "Excluir cliente",
            "label_other": "Excluir clientes",
            "moreOptions": "Mais opções",
            "people": "Pessoas",
            "peopleInfo": "Os contatos permanecerão em {<people>}",
            "projects": "Projetos",
            "projectsInfo": "Projetos e solicitações de clientes permanecerão em {<projects>}",
            "restore": "Você pode restaurar um cliente excluído em {<restoreDays>} por meio do menu {<moreOptions>}.",
            "restoreDays": "45 dias",
            "solutionsInfo": "Os recursos das soluções instaladas permanecerão nos painéis de soluções",
            "successMessage_one": "Cliente excluído",
            "successMessage_other": "Clientes excluídos"
          },
          "dropdownLabel": "Actions",
          "editDetails": "Editar detalhes"
        },
        "optionsMenu": "Open client options",
        "resetSelection": "Redefinir seleção",
        "selectedCount": "{{count}} selected"
      },
      "clientFindAndSelect": {
        "addNewClient": "Add new client",
        "cancel": "Cancel",
        "save": "Save",
        "searchClientsPlaceholder": "Select clients",
        "selectClients": "Select one or more clients"
      },
      "clientGroupMembers": {
        "allClientContacts": "All client contacts of {{groupName}}",
        "allServiceTeamMembers": "All team members of {{groupName}}",
        "columns": {
          "email": "Email",
          "name": "Name"
        },
        "description": "You can manage the users in this group from the client.",
        "genericGroupName": "Grupo de clientes {{groupName}}",
        "membersFromClientContacts": "{{count}} client contacts from {{groupName}}",
        "membersFromServiceTeam": "{{count}} service team members from {{groupName}}",
        "primaryClientContacts": "Primary client contacts of {{groupName}}",
        "primaryServiceTeamMembers": "Primary team members of {{groupName}}"
      },
      "clientIntake": {
        "addContact": {
          "addExisting": "Add from existing contacts",
          "createNew": "Criar novo",
          "selectContactPlaceholder": "Pesquisar por nome ou email",
          "title": "Detalhes de contato principal"
        },
        "clientDetails": {
          "clientId": {
            "duplicateError": "O ID de cliente já existe, insira um ID de cliente exclusivo.",
            "help": "Client ID is a unique identifier used to differentiate clients and match records with other systems.",
            "label": "ID do cliente (opcional)"
          },
          "customAttributesTitle": "Custom details",
          "internalName": {
            "duplicateError": "O nome interno já existe, insira um nome interno exclusivo.",
            "help": "Isso só é visível para membros internos da equipe.",
            "label": "Nome de exibição interno",
            "requiredError": "O nome interno não pode ficar vazio."
          },
          "title": "Detalhes do cliente"
        },
        "create": {
          "button": "Criar",
          "clientName": "Nome",
          "clientType": "Tipo de cliente",
          "createError": "Falha ao criar o cliente",
          "createdTitle": "Cliente criado",
          "ftuHelp": "Parágrafo curto ou marcadores que descrevem o valor da criação de uma entidade cliente. ",
          "title": "Criar novo cliente"
        },
        "createContact": {
          "duplicateError": "Este contato já existe. Atribua um contato sugerido ou insira um endereço de email diferente."
        },
        "linkFolders": {
          "browseFolders": "Browse folders",
          "linkFoldersAndFiles": "Link folders",
          "linkFoldersInfo": "Link folders and files for this client to keep everything in one place.",
          "linkFoldersTitle": "Does this client have any files or folders you would like to link here?",
          "skip": "Skip and link later"
        }
      },
      "clientUpdate": {
        "cancel": "Cancelar",
        "clientNameLabel": "Nome",
        "submitLabel": "Salvar",
        "successMessage": "Cliente atualizado",
        "updateDrawerTitle": "Editar detalhes do cliente",
        "updateError": "Falha ao atualizar o cliente"
      },
      "clientlist": {
        "actions": {
          "filter": {
            "all": "Tudo",
            "company": "Empresa",
            "individual": "Individual",
            "showMyClientsLabel": "Mostrar apenas meus clientes",
            "type": "Tipo de cliente"
          },
          "searchPlaceholder": "Pesquisar clientes",
          "sortLabel": "Classificar por",
          "sortOptions": {
            "createdAsc": "Mais antigo",
            "createdDesc": "Mais recente",
            "createdLabel": "Data de criação",
            "nameAsc": "A - Z",
            "nameDesc": "Z - A",
            "nameLabel": "Nome"
          },
          "sortOrder": "Ordem de classificação"
        },
        "column": "Client",
        "heading": {
          "actions": {
            "settings": "Configurações"
          },
          "create": "Criar cliente",
          "manage": "Manage",
          "manageClientHub": "Manage client hub",
          "options": "Options",
          "title": "Client hub"
        },
        "optionsMenu": "Open Client Hub options",
        "queryEmptyState": {
          "cannotCreateDescription_first": "Primary team members can add others to the service team of a client.",
          "cannotCreateDescription_second": "To create new clients, contact your account admin for access.",
          "cannotCreateTitle": "You don't have permissions to manage clients",
          "clearFilter_one": "Limpar filtro",
          "clearFilter_other": "Limpar filtros",
          "description": "Crie um cliente para organizar e gerenciar seu trabalho.",
          "filterDoesNotMatchClient_one": "O filtro não corresponde a nenhum cliente",
          "filterDoesNotMatchClient_other": "Os filtros não correspondem a nenhum cliente",
          "notOnServiceTeam": {
            "description_first": "Primary team members of a client can add others to the service team.",
            "description_second": "Creating a client automatically assigns you to its service team.",
            "showAllClients": "Show all clients",
            "title": "You are not on the service team for any clients yet."
          },
          "title": "Nenhum cliente criado ainda"
        },
        "recentlyDeleted": {
          "description": "Armazenaremos aqui os clientes excluídos recentemente por {{days}} dias.",
          "emptyState": {
            "primaryMessage": "You don't have any recently deleted clients."
          },
          "restore": {
            "button": "Restaurar",
            "confirmMessageFirst": "Tem certeza de que deseja restaurar {{clientName}}?",
            "confirmMessageSecond": "Todos no cliente recuperarão o acesso aos recursos do cliente.",
            "confirmModalTitle": "Restaurar cliente",
            "errorMessage": "Falha ao restaurar o cliente",
            "successMessage": "Cliente restaurado"
          },
          "table": {
            "columns": {
              "deletedBy": "Excluído por",
              "deletedOn": "Excluído em",
              "name": "Nome"
            }
          },
          "title": "Excluído recentemente"
        },
        "searchEmptyState": {
          "clearSearch": "Limpar pesquisa",
          "description": "Não foi possível encontrar {<searchTerm>} em nenhum cliente.",
          "title": "Sua pesquisa não corresponde a nenhum cliente"
        }
      },
      "clientsTable": {
        "columns": {
          "actionsHeader": "Client actions",
          "name": "Nome",
          "primaryContact": {
            "label": "Contato principal",
            "no": "Não",
            "yes": "Sim"
          }
        },
        "loadMore": "Load more",
        "rows": {
          "select": "Select client {{clientName}}"
        }
      },
      "clientview": {
        "menuSection": {
          "people": "Pessoas",
          "services": "Serviços"
        },
        "primaryMenuLabel": "Add people or create services",
        "tabs": {
          "contacts": "Contatos",
          "disabledTabTooltip": "Only service team members have access. Contact a primary team member to join.",
          "files": "Arquivos",
          "overview": "Visão geral",
          "projects": "Projetos"
        }
      },
      "common": {
        "clearSelection": "Clear selection",
        "delete": "Delete"
      },
      "contactActions": {
        "addContact": "Adicionar contato",
        "editColumns": "Edit columns"
      },
      "contactIntake": {
        "add": "Adicionar",
        "addAsPrimaryTeamMember": "Add individuals as primary team members",
        "addClientContactsLabel": "Select one or more contacts",
        "addIndividualMembers": "Add individual members",
        "addServiceTeamLabel": "Select one or multiple service teams",
        "addServiceTeamSuccessMessage_one": "Added service team",
        "addServiceTeamSuccessMessage_other": "Added service teams",
        "addServiceTeams": "Add service teams",
        "addTeamMemberLabel": "Select one or multiple team members",
        "addTeamMemberSuccessMessage_one": "Added team member",
        "addTeamMemberSuccessMessage_other": "Added team members",
        "advancedDetails": "Advanced details",
        "assignRequest": "Assign requests to client contacts.",
        "cancel": "Cancelar",
        "contactExistsError": "O contato com este email já existe no cliente.",
        "create": "Criar",
        "createNewContactTitle": "Criar um novo contato",
        "createServices": "Crie serviços para o cliente.",
        "email": "Email",
        "employeeDomainError": "This user must be added as an employee",
        "errorMessage_one": "Falha ao adicionar contato",
        "errorMessage_other": "Falha ao adicionar contatos",
        "firstName": "Nome",
        "join": "Join",
        "joinAsPrimaryTeamMember": "Join as primary team member",
        "joinServiceTeamSuccessMessage": "Joined service team",
        "lastName": "Sobrenome",
        "multiClientPrimaryAlertChecked": "Users already on the client's service team will be set as primaries. If they're already primary, no changes will be made.",
        "multiClientPrimaryAlertRemain": "Users already set as primaries of a client will remain in that role.",
        "next": "Avançar",
        "primaryTeamMemberInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
        "searchServiceTeamsPlaceholder": "Search by name",
        "serviceTeamPrimaryAlert": "Members of a service team already set as primaries of a client will remain in that role.",
        "successMessage_one": "Contato adicionado",
        "successMessage_other": "Contatos adicionados",
        "teamMemberInfo": "Assigned team members can:",
        "viewAllServices": "View client requests and services they have access to.",
        "viewFoldersAndFiles": "View folders and files they have access to."
      },
      "contactType": {
        "primary": "Principal"
      },
      "contactsTab": {
        "actions": {
          "cancel": "Cancelar",
          "confirm": "Confirmar",
          "edit": {
            "label": "Edit contact",
            "successMessage": "Updated contact details"
          },
          "manageUserLabel": "Gerenciar usuário",
          "remove": {
            "confirmModalTitle_one": "Remover contato do cliente",
            "confirmModalTitle_other": "Remover contatos do cliente",
            "confirmRemoveMessageFirst_one": "Tem certeza de que deseja remover este contato deste cliente?",
            "confirmRemoveMessageFirst_other": "Tem certeza de que deseja remover estes contatos deste cliente?",
            "confirmRemoveMessageSecond": "Você ainda poderá encontrá-los em Pessoas.",
            "confirmRemoveMessageThird": "To delete them entirely, go to {<people>}.",
            "errorMessage_one": "Não foi possível remover o contato",
            "errorMessage_other": "Não foi possível remover os contatos",
            "label": "Remover",
            "removeOk": "Remover",
            "successMessage_one": "Contato removido",
            "successMessage_other": "Contatos removidos"
          },
          "removePrimary": {
            "confirmButtonText": "Remover designação principal",
            "confirmModalTitle": "Remover designação principal",
            "confirmRemovePrimaryMessageFirst_one": "Tem certeza de que deseja remover a designação de contato principal desta pessoa?",
            "confirmRemovePrimaryMessageFirst_other": "Tem certeza de que deseja remover a designação de contato principal destas pessoas?",
            "confirmRemovePrimaryMessageSecond_one": "Esta pessoa não receberá mais notificações sobre a atividade do cliente, mas ainda será um contato deste cliente.",
            "confirmRemovePrimaryMessageSecond_other": "Eles não receberão mais notificações sobre a atividade do cliente, mas ainda serão contatos deste cliente.",
            "errorMessage_one": "Não foi possível atualizar o contato",
            "errorMessage_other": "Não foi possível atualizar os contatos",
            "label": "Remover designação principal",
            "successMessage_one": "Detalhes de contato atualizados",
            "successMessage_other": "Detalhes de contatos atualizados"
          },
          "removeRestrictionTooltip": "Clients must have at least one primary contact. Add or assign another.",
          "removeServiceContact": {
            "confirmModalTitle": "Remover membro da equipe do cliente",
            "confirmRemoveMessage": "Tem certeza de que deseja remover {{contactName}}?",
            "errorMessage": "Não foi possível remover o membro da equipe",
            "removeOk": "Remover",
            "successMessage": "Membro da equipe removido"
          },
          "removeServiceTeam": {
            "confirmModalTitle": "Remove service team from client",
            "confirmRemoveMessage": "Are you sure you want to remove {{contactName}}?",
            "errorMessage": "Service team could not be removed",
            "removeOk": "Remove",
            "successMessage": "Removed service team"
          },
          "removeTeamMemberPrimaryDesignation": {
            "confirmButtonText": "Remover designação principal",
            "confirmModalTitle": "Remover designação principal",
            "confirmRemovePrimaryMessage": "Tem certeza de que deseja remover a designação de membro principal da equipe desta pessoa?",
            "errorMessage": "Não foi possível atualizar o membro da equipe",
            "successMessage": "Membro da equipe atualizado com êxito"
          },
          "setPrimary": {
            "confirmButtonText_one": "Tornar contato principal",
            "confirmButtonText_other": "Tornar contatos principais",
            "confirmModalTitle_one": "Tornar contato principal",
            "confirmModalTitle_other": "Tornar contatos principais",
            "confirmSetPrimaryMessageFirst_one": "Tem certeza de que deseja tornar esta pessoa o contato principal deste cliente?",
            "confirmSetPrimaryMessageFirst_other": "Tem certeza de que deseja tornar estas pessoas os contatos principais deste cliente?",
            "confirmSetPrimaryMessageSecond": "Os contatos principais recebem notificações da atividade do cliente e são atribuídos a todas as novas tarefas do cliente.",
            "errorMessage_one": "Não foi possível definir o contato principal",
            "errorMessage_other": "Não foi possível definir os contatos principais",
            "label": "Tornar contato principal",
            "successMessage_one": "Detalhes de contato atualizados",
            "successMessage_other": "Detalhes de contatos atualizados"
          },
          "setPrimaryTeamMember": {
            "confirmButtonText": "Tornar membro principal da equipe",
            "confirmModalTitle": "Tornar membro principal da equipe",
            "confirmSetPrimaryMessage": "Tem certeza de que deseja tornar esta pessoa o membro principal da equipe deste cliente?",
            "errorMessage": "Não foi possível atualizar o membro da equipe",
            "successMessage": "Membro da equipe atualizado com êxito"
          }
        },
        "email": "Email",
        "name": "Nome"
      },
      "createCustomFields": {
        "addDropdownOption": "Add an option",
        "clientCustomField": "Client custom field",
        "clientInfo": "This will be added as an optional field for all new and existing clients.",
        "clientSchemaOptions": {
          "all": "All clients",
          "individual": "Individual clients only",
          "organization": "Company clients only"
        },
        "clientType": "Apply this custom field to:",
        "contactCustomField": "Contact custom field",
        "contactInfo": "This will be added as an optional field for all new and existing client contacts.",
        "createFailed": {
          "message": "You've reached the maximum number of custom fields allowed. Delete one before adding another.",
          "title": "Failed to create custom field"
        },
        "drawerTitle": "Create custom field",
        "drawerTitleClient": "Create client custom field",
        "drawerTitleContact": "Create contact custom field",
        "dropdownLengthExceeded": "Each option must be {{limit}} characters or less.",
        "dropdownTitle": "Dropdown list options",
        "errorMessage": "Failed to create custom field",
        "fieldName": "Name",
        "fieldNameHelp": "Custom field key: {{fieldKey}}",
        "fieldPlaceholder": "Select an option",
        "fieldType": "Field type",
        "propertyExists": "Create failed: a custom field with the same key already exists.",
        "submit": "Create",
        "successMessage": "Created custom field"
      },
      "editColumns": {
        "apply": "Apply",
        "cancel": "Cancel",
        "drawerInfo": "These selections will be applied to all clients.",
        "drawerMessage": "Choose which columns to show and set their order on the table."
      },
      "editCustomFields": {
        "drawerTitle": "Edit custom field",
        "drawerTitleClient": "Edit client custom field",
        "drawerTitleContact": "Edit contact custom field",
        "submit": "Save"
      },
      "navigateFromFolderToClient": {
        "linkedClients": "{{count}} clients linked"
      },
      "serviceTeams": {
        "addMembers": {
          "cancelLabel": "Cancel",
          "errorMissingParameters": "Error: Missing parameters",
          "noContactsSelected": "No contacts selected",
          "submitLabel": "Add",
          "title": "Add team members"
        },
        "breadcrumb": {
          "clientHub": "Client Hub"
        },
        "clientHubDisabledBanner": "Client hub is currently disabled. Service teams will only be available when it’s enabled.",
        "contextBar": {
          "delete": "Delete",
          "deleteConfirmation": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "confirmMessageSecond_one": "Team members of this service team will no longer have access to any clients linked to this service team, unless they already have direct access to those clients.",
            "confirmMessageSecond_other": "Team members of these service teams will no longer have access to any clients linked to these service teams, unless they already have direct access to those clients.",
            "confirmMessage_one": "Are you sure you want to delete this service team? Team members of this service team will not get deleted.",
            "confirmMessage_other": "Are you sure you want to delete these service teams? Team members of these service teams will not get deleted.",
            "title": "Delete service team",
            "title_other": "Delete service teams"
          },
          "edit": "Edit service team",
          "more": "More",
          "noSelection": "Select service teams to see actions",
          "options": "Options",
          "optionsMenu": "Open service team options",
          "selectedCount": "{{count}} selected",
          "selectedCount_one": "{{count}} selected",
          "selectedCount_other": "{{count}} selected"
        },
        "createTeam": {
          "title": "Create service team"
        },
        "delete": {
          "errorMessage": "Failed to delete service team",
          "errorMessage_other": "Failed to delete service teams",
          "successMessage": "Deleted service team",
          "successMessage_other": "Deleted {{count}} service teams"
        },
        "emptyState": {
          "createButton": "Create service team",
          "subtitle": "Start by creating service teams to assign to clients.",
          "title": "There aren't any service teams yet"
        },
        "manage": "Manage service teams",
        "manageServiceTeam": {
          "addMembers": "Add team members",
          "cancel": "Cancel",
          "confirmation": {
            "accessWarning": "Removing team members will remove their access to clients linked to this service team, unless they already have direct access to those clients.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",
            "madePrimary": "Made team members primary",
            "message": "Are you sure you want to proceed with the following updates for this service team?",
            "removedMembers": "Removed team members",
            "title": "Confirm edits"
          },
          "create": {
            "errorMessage": "Failed to create service team",
            "save": "Create",
            "successMessage": "Created service team",
            "title": "Create service team"
          },
          "details": "Details",
          "edit": {
            "errorMessage": "Service team update failed",
            "save": "Save",
            "successMessage": "Updated service team",
            "title": "Edit service team"
          },
          "members": "Team members",
          "name": "Service team name",
          "namePlaceholder": "Enter service team name",
          "nameRequired": "Please enter a service team name",
          "noMembersSubtitle": "Start by adding team members",
          "noMembersTitle": "This service team doesn't have any members",
          "primaryMembersInfo": "Primary service team members can edit client details, assign new primaries, and delete clients.",
          "table": {
            "actions": "Actions",
            "clearSelection": "Clear selection",
            "email": "Email",
            "makePrimary": "Make primary",
            "makePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Make primary",
              "messageLine1": "Are you sure you want to make this team member a primary on this service team?",
              "messageLine2": "Primary service team members can edit client details, assign new primaries, and delete clients.",
              "title": "Make primary"
            },
            "memberActions": "Member actions",
            "name": "Name",
            "primary": "Primary",
            "regular": "Regular",
            "remove": "Remove",
            "removePrimaryDesignation": "Remove primary designation",
            "removePrimaryModal": {
              "cancelButton": "Cancel",
              "confirmButton": "Remove primary designation",
              "messageLine1": "Are you sure you want to remove this person's primary team member designation?",
              "messageLine2": "This person will no longer receive notifications of client activity from clients assigned to the service team.",
              "title": "Remove primary designation"
            },
            "searchPlaceholder": "Search team members",
            "selectedCount": "{{count}} selected",
            "type": "Member type"
          }
        },
        "searchEmptyState": {
          "clearSearch": "Clear search",
          "description": "We can't find any service teams that match your search for {<searchTerm>}. Try searching for something else.",
          "title": "No service teams found"
        },
        "subtitle": "Create and manage service teams that can be assigned to clients.",
        "table": {
          "actionsAriaLabel": "Actions for {{teamName}}",
          "addMembers": "Add team members",
          "ariaLabel": "Service teams table",
          "editTeamAriaLabel": "Edit {{teamName}} service team",
          "loadingAriaLabel": "Loading more service teams",
          "more": "more",
          "name": "Name",
          "noMembers": "No members",
          "scrollRegionAriaLabel": "Service teams table scroll region",
          "searchPlaceholder": "Search service teams",
          "selectAllTeamsAriaLabel": "Select all teams",
          "selectTeam": "Select {{teamName}}",
          "teamMembers": "Team members"
        },
        "title": "Service teams"
      },
      "suggestedContacts": {
        "addClient": "Adicionar contato",
        "addError": "Não foi possível adicionar os contatos",
        "addSuccessMessage": "Contato adicionado com êxito",
        "confirmAddClientInfo": "Tem certeza de que deseja adicionar {{contactName}} como um contato?",
        "dismissSuggestedContact": "Dismiss suggested contact",
        "noNotificationInfo": "O contato não será notificado.",
        "sameDomainContactsMessage_one": "Há 1 contato com o mesmo domínio de email do contato principal.",
        "sameDomainContactsMessage_other": "Há {{count}} contatos com o mesmo domínio de email do contato principal.",
        "selectSuggestedClient": "Select suggested contact",
        "title": "Contatos sugeridos"
      },
      "suggestedContactsDrawer": {
        "addContacts_one": "Adicionar contato",
        "addContacts_other": "Adicionar contatos",
        "addSuccess_one": "Contato adicionado",
        "addSuccess_other": "Contatos adicionados",
        "cancel": "Cancelar",
        "emailField": "Email",
        "nameField": "Nome",
        "selectContactsInfoMessage": "Selecione os contatos que você gostaria de adicionar a este cliente.",
        "title": "Adicionar contatos sugeridos"
      },
      "trialMode": {
        "betaDisclaimer": "This is a Beta feature",
        "betaTagText": "Beta",
        "clientHubSettings": "Client hub settings",
        "description": "Trial the new client hub experience with specific users in your organization.",
        "enableLabel": "Enable trial mode",
        "exclusionAdminMessage": "Admins can manage who has trial access in {<settings>}.",
        "exclusionContactMessage": "Contact your account admin to get access.",
        "exclusionHeading": "Client hub is not available to you yet.",
        "exclusionMessage": "Your account is testing the new client hub experience with selected users.",
        "heading": "Trial mode",
        "manageAccess": "Manage trial access",
        "offValue": "Off",
        "onValue": "On",
        "usersLabel": "Select one or multiple users"
      },
      "validation": {
        "formats": {
          "email": "Forneça um endereço de email válido"
        },
        "maxLengthError": "Please enter no more than {{maxLength}} characters",
        "required": "Insira {{name}}"
      },
      "viewServiceTeamMembers": {
        "adminMessage": "Manage members from this team from {<serviceTeamsLink>}.",
        "adminMessageWithoutLink": "Manage members for this team from Service Teams.",
        "memberCount_one": "{{count}} service team member",
        "memberCount_other": "{{count}} service team members",
        "nonAdminMessage": "Team members and member types are managed by your account admin.",
        "serviceTeamsLinkText": "Service Teams",
        "titleSuffix": "(Service team)",
        "viewMembersAction": "View members"
      },
      "widgets": {
        "clientContacts": {
          "noPrimaryContactsLabel": "Nenhum contato principal",
          "primaryContact": "(Principal)",
          "title": "Contatos",
          "viewAll": "Exibir tudo"
        },
        "clientDetails": {
          "edit": "Editar",
          "properties": {
            "clientId": "ID de cliente",
            "clientType": "Tipo de cliente",
            "internalName": "Nome de exibição"
          },
          "title": "Detalhes do cliente"
        },
        "clientRequests": {
          "accessRestricted": {
            "joinButton": "Join service team",
            "joinMessage": "Join the service team to get access to all client requests, services, and files.",
            "secondaryMessage": "Contact a primary service team member to request to join the service team.",
            "title": "You have restricted access on this client"
          },
          "emptyState": {
            "secondaryMessage": "Inicie um serviço para solicitar arquivos ou informações, enviar documentos para assinatura ou aprovações.",
            "title": "Nenhum trabalho foi criado para este cliente"
          },
          "title": "Solicitações de clientes"
        },
        "serviceContacts": {
          "add": "Add",
          "description": "Team members assigned to the client gain access to all client requests, services, and files. Primary team members can edit client details, assign new primaries, and delete clients.",
          "drawerTitle": "Adicionar à equipe de serviço",
          "joinTeamTitle": "Join service team",
          "notFound": "No results found",
          "optionsMenu": "Open service contact options",
          "primaryContact": "(Principal)",
          "remove": "Remover do cliente",
          "removePrimaryDesignation": "Remover designação principal",
          "search": "Selecione um ou vários membros da equipe",
          "searchPlaceholder": "Pesquisar por nome ou email",
          "setPrimary": "Tornar membro principal da equipe",
          "title": "Assigned team members",
          "viewAll": "Exibir tudo"
        },
        "suggestedClients": {
          "title": "Clientes sugeridos"
        },
        "suggestedContacts": {
          "title": "Contatos sugeridos",
          "viewAll": "Exibir tudo"
        }
      }
    }
  }
];